// es translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const es = {
    // Payouts
    "payouts.title": "Centro de Pagos",
    "payouts.subtitle": "Administre sus regalías, ganancias y métodos de pago.",
    "payouts.withdrawableBalance": "Saldo Retirable",
    "payouts.totalEarnings": "Ganancias Totales",
    "payouts.pending": "Pendiente",
    "payouts.requestPayout": "Solicitar Pago",
    "payouts.createRequest": "Crear Solicitud de Pago",
    "payouts.requestDesc": "Inicie una transferencia a su método de pago registrado.",
    "payouts.amount": "Monto ($)",
    "payouts.minAmountShort": "Mín: $50",
    "payouts.bankTransfer": "Transferencia Bancaria",
    "payouts.paypal": "PayPal",
    "payouts.confirmRequest": "Confirmar Solicitud",
    "payouts.completedWithdrawals": "Retiros Completados",
    "payouts.totalWithdrawn": "Total Retirado",
    "payouts.transactionHistory": "Historial de Transacciones",
    "payouts.paymentMethods": "Métodos de Pago",
    "payouts.recentTransactions": "Transacciones Recientes",
    "payouts.noTransactions": "Sin Transacciones Aún",
    "payouts.noTransactionsDesc": "Sus solicitudes de pago pasadas se listarán aquí.",
    "payouts.statusPaid": "Pagado",
    "payouts.statusRequested": "Pendiente",
    "payouts.noPaymentMethod": "No Hay Método de Pago",
    "payouts.addMethodDesc": "Agregue un método de pago para retirar sus ganancias.",
    "payouts.addMethod": "Añadir Método",
    "payouts.verified": "Verificado",
    "payouts.pendingVerification": "Verificación Pendiente",
    "payouts.changeMethod": "Cambiar Método de Pago",
    "payouts.methodDesc": "Ingrese los detalles de su método de pago para recibir sus ganancias.",
    "payouts.bank": "Banco",
    "payouts.accountHolder": "Nombre del Titular",
    "payouts.bankName": "Nombre del Banco",
    "payouts.ibanOrAccount": "IBAN o Número de Cuenta",
    "payouts.swiftBic": "Código SWIFT/BIC",
    "payouts.paypalEmail": "Correo Electrónico de PayPal",
    "payouts.securityVerification": "Verificación de Seguridad",
    "payouts.enterVerificationCodeDesc": "Ingrese el código de 6 dígitos enviado a su correo electrónico para confirmar la transacción.",
    "payouts.remainingAttempts": "Intentos restantes:",
    "payouts.sendNewCode": "Enviar Nuevo Código",
    "payouts.deleteMethod": "Eliminar Método",
    "payouts.deleteMethodConfirm": "¿Está seguro de que desea eliminar este método de pago?",
    
    // Viral Campaign
    "viral.tiktokName": "Campaña de TikTok",
    "viral.instagramName": "Instagram Reels",
    "viral.twitterName": "Twitter/X Viral",
    "viral.campaignTitleFallback": "Campaña Viral",
    "viral.campaignDescFallback": "Campaña Viral",
    "viral.day": "Día",
    "viral.activeCampaignsTitle": "Campañas Activas",
    "viral.campaignFallback": "Campaña",
    "viral.activeStatus": "Activo",

    // Mastering
    "mastering.presetStreaming": "Streaming (Spotify/Apple)",
    "mastering.presetYoutube": "Vídeo (YouTube)",
    "mastering.presetCD": "Master de CD",
    "mastering.presetClub": "Club / EDM",
    "mastering.presetAcoustic": "Acústico / Jazz",
    "mastering.presetPodcast": "Podcast / Voz",
    "mastering.band": "Banda",
    "mastering.loudness": "Sonoridad",
    "mastering.integratedLufs": "LUFS Integrado",
    "mastering.truePeak": "Pico Verdadero",
    "mastering.dynamicRange": "Rango Dinámico",
    "mastering.eq": "Ecualizador",
    "mastering.bass": "Bajos",
    "mastering.mid": "Medios",
    "mastering.treble": "Agudos",
    "mastering.processing": "Procesando",
    "mastering.stereoWidth": "Ancho Estéreo",
    "mastering.compression": "Compresión",
    "mastering.saturation": "Saturación",
    "mastering.additionalProcessing": "Procesamiento Adicional",
    "mastering.deEsser": "De-Esser",
    "mastering.limiterCeiling": "Límite del Limitador",
    "mastering.aiAnalyzing": "Análisis de IA",
    "mastering.masteringProcessing": "Procesamiento de Mastering",
    "mastering.analyzingDesc": "Analizando audio...",
    "mastering.processingDesc": "Aplicando mastering...",
    "mastering.brightness": "Brillo",

    // Subscription
    "subscription.freeDesc": "Inicie su viaje musical",
    "subscription.artistDesc": "Para artistas serios",
    "subscription.labelDesc": "Para sellos y mánagers",
    "subscription.featFree1": "1 lanzamiento (de por vida)",
    "subscription.featFree2": "20% de comisión",
    "subscription.featFree3": "Entrega estándar (2-5 días)",
    "subscription.featFree4": "Soporte por correo electrónico",
    "subscription.featArtist1": "Subidas ilimitadas",
    "subscription.featArtist2": "0% de comisión",
    "subscription.featArtist3": "Entrega rápida (24-72h)",
    "subscription.featArtist4": "Análisis básico",
    "subscription.featArtist5": "Sistema de reparto",
    "subscription.featArtist6": "Soporte prioritario por correo electrónico",
    "subscription.featLabel1": "Gestión de múltiples artistas",
    "subscription.featLabel2": "Repartos avanzados",
    "subscription.featLabel3": "Subida masiva",
    "subscription.featLabel4": "Análisis avanzado",
    "subscription.featLabel5": "Distribución rápida",
    "subscription.featLabel6": "Soporte prioritario",

    // Common
    "common.loading": "Cargando...",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.delete": "Eliminar",
    "common.edit": "Editar",
    "common.submit": "Enviar",
    "common.back": "Atrás",
    "common.next": "Siguiente",
    "common.previous": "Anterior",
    "common.search": "Buscar",
    "common.filter": "Filtrar",
    "common.all": "Todos",
    "common.yes": "Sí",
    "common.no": "No",
    "common.logout": "Cerrar Sesión",
    "common.login": "Iniciar Sesión",
    "common.register": "Registrarse",
    
    // Auth
    "auth.welcome": "Bienvenido",
    "auth.signIn": "Inicia sesión en tu cuenta",
    "auth.email": "Correo electrónico",
    "auth.password": "Contraseña",
    "auth.loginButton": "Iniciar Sesión",
    "auth.noAccount": "¿No tienes cuenta? Regístrate con un enlace de invitación.",
    "auth.loginSuccess": "Inicio de sesión exitoso",
    "auth.loginFailed": "Error de inicio de sesión",

    "auth.loginBtn": "INICIAR SESIÓN",
    "auth.createAccount": "Crear Cuenta",
    "auth.firstName": "Nombre",
    "auth.lastName": "Apellido",
    "auth.accountType": "Tipo de Cuenta",
    "auth.artist": "Artista",
    "auth.label": "Sello Discográfico",
    "auth.address": "Dirección",
    "auth.city": "Ciudad",
    "auth.country": "País",
    "auth.postalCode": "Código Postal",
    "auth.phone": "Teléfono",
    "auth.currency": "Moneda",
    "auth.hasAccount": "¿Ya tienes una cuenta?",
    "auth.registerBtn": "REGISTRARSE",
    "auth.agreeTerms": "Acepto los Términos de Servicio y la Política de Privacidad",
    "auth.registerSubtitle": "Únete a la plataforma de distribución musical",
    "auth.individualArtist": "Artista individual",
    "auth.recordLabel": "Sello discográfico",
    "auth.labelInformation": "Información del Sello",
    "auth.labelName": "Nombre del Sello",
    "auth.labelDescription": "Descripción del Sello",
    "auth.website": "Sitio Web",
    "auth.instagram": "Instagram",
    
    // Navigation
    "nav.dashboard": "Panel",
    "nav.releases": "Lanzamientos",
    "nav.payouts": "Pagos",
    "nav.support": "Soporte",
    "nav.help": "Ayuda y guías",
    "nav.analytics": "Estadísticas",
    "nav.referrals": "Referencias",
    "nav.subscription": "Suscripción",
    "nav.splits": "División de ingresos",
    "nav.promotions": "Promociones",
    "nav.profile": "Perfil",
    "nav.playlistExplorer": "Explorador de listas de reproducción",
    "nav.aiMatcher": "Comparador de IA",
    "nav.campaigns": "Campañas",
    "nav.bioLink": "Enlace biológico",
    "nav.canvasStudio": "Estudio de lienzo",
    "nav.aiVideo": "Vídeo de IA",
    "nav.viralCampaign": "Campaña viral",
    "nav.aiStudio": "Estudio de IA",
    "nav.aiMastering": "Dominio de la IA",
    "nav.mixMastering": "Masterización de mezcla",
    "nav.lyricsManager": "Administrador de letras",
    "nav.contributors": "Colaboradores",
    "nav.aiAdvisor": "Asesor de IA",
    "nav.connections": "Conexiones",
    "nav.preSave": "Preguardar",
    "nav.smartLinks": "Enlaces inteligentes",
    "nav.qrCodes": "Códigos QR",
    "nav.collaborations": "Colaboraciones",
    "nav.lyricsSync": "Sincronización de letras",
    "nav.section.music": "musica",
    "nav.section.discover": "Descubrir",
    "nav.section.promotion": "Promoción",
    "nav.section.aiStudio": "Estudio de IA",
    "nav.section.career": "carrera",
    "nav.section.finance": "Finanzas",
    "nav.section.growth": "Crecimiento",
    "nav.section.marketing": "Marketing",
    "nav.section.tools": "Herramientas",
    "nav.section.community": "Comunidad",
    "nav.section.support": "Soporte",
    "nav.logout": "Cerrar sesión",
    "nav.comingSoon": "Beta",
    "notifications.markAllRead": "Marcar todo como leído",
    "notifications.empty": "Aún no hay notificaciones",
    
    // Dashboard
    "dashboard.welcome": "Bienvenido",
    "dashboard.subtitle": "Gestiona tu música, sigue tus lanzamientos y ve tus ganancias.",
    "dashboard.totalReleases": "Lanzamientos Totales",
    "dashboard.totalTracks": "Pistas Totales",
    "dashboard.balance": "Saldo Actual",
    "dashboard.withdrawable": "Retirable",
    "dashboard.recentReleases": "Lanzamientos Recientes",
    "dashboard.viewAll": "Ver Todo",
    "dashboard.topTracks": "Más Escuchados",
    "dashboard.recentActivities": "Actividades Recientes",

    "dashboard.viewDetails": "Ver Detalles",
    "dashboard.viewAnalytics": "Ver Analíticas",
    "upload.status": "Estado de Carga",
    "upload.none": "Sin Cargas",
    "upload.noneDesc": "No hay cargas en curso actualmente.",
    "auth.pendingApproval": "Aprobación Pendiente",
    "auth.pendingApprovalDesc": "Su cuenta está pendiente de aprobación por el administrador.",
    "auth.accountApproved": "¡Su cuenta ha sido aprobada!",
    "auth.accountRejected": "Su cuenta ha sido rechazada.",
    "auth.accountPendingInfo": "Su cuenta aún está pendiente de aprobación.",
    "auth.invalidResetLink": "Enlace de restablecimiento de contraseña no válido",
    "auth.passwordLengthError": "La contraseña debe tener al menos 6 caracteres",
    "auth.passwordsDoNotMatch": "Las contraseñas no coinciden",
    "auth.passwordChangedSuccess": "¡Su contraseña ha sido cambiada con éxito!",
    "auth.passwordResetFailed": "Fallo al restablecer la contraseña",
    "auth.passwordChanged": "¡Contraseña Cambiada!",
    "auth.passwordChangedDesc": "Su contraseña se ha actualizado con éxito. Puede iniciar sesión con su nueva contraseña.",
    "auth.goToLogin": "Ir a la Página de Inicio de Sesión",
    "auth.setNewPassword": "Establecer Nueva Contraseña",
    "auth.setNewPasswordDesc": "Cree una nueva contraseña para su cuenta.",
    "auth.newPassword": "Nueva Contraseña",
    "auth.confirmPassword": "Confirmar Contraseña",
    "auth.changePassword": "Cambiar Contraseña",
    "releases.release": "Lanzamiento",
    "releases.artist": "Artista",
    "releases.status": "Estado",
    "releases.date": "Fecha",
    "releases.actions": "Acciones",
    "releases.deleteRelease": "Eliminar",
    "releases.noSearchMatch": "No hay lanzamientos que coincidan con su búsqueda. Intente con otras palabras clave.",
    "releases.createFirst": "Cree su primer lanzamiento musical y compártalo con sus oyentes en todas las plataformas.",
    "releases.deleteReleaseConfirm": "¿Está seguro de que desea eliminar el lanzamiento '{releaseName}'?",
    "releases.cannotBeUndone": "Esta acción no se puede deshacer.",
    "metadata.copied": "¡{label} copiado!",
    "metadata.copyFailed": "Error al copiar",
    "metadata.copy": "Copiar",
    "metadata.downloaded": "¡{label} descargado!",
    "metadata.downloadFailed": "Error en la descarga",
    "metadata.dspCopied": "¡Resumen del DSP copiado al portapapeles!",
    "metadata.copyDsp": "Copiar Resumen del DSP",
    "metadata.noAudio": "Archivo de audio no subido",
    "metadata.noCover": "Arte de portada no subido",
    "dashboard.drafts": "Borradores",
    "dashboard.untitled": "Sin título",
    "dashboard.noGenre": "Sin género",
    "dashboard.clickToEdit": "Haz clic para editar",
    "dashboard.newRelease": "Crear Nuevo Lanzamiento",
    "dashboard.newReleaseDesc": "Comparte tu música con el mundo",
    "dashboard.requestPayout": "Solicitar Pago",
    "dashboard.noReleases": "Sin lanzamientos aún",
    "dashboard.createFirst": "Crea tu primer lanzamiento para comenzar.",
    "dashboard.greetingMorning": "Buenos dias",
    "dashboard.greetingAfternoon": "Buenas tardes",
    "dashboard.greetingEvening": "Buenas noches",
    "dashboard.artist": "Artista",
    "dashboard.lastLogin": "Último inicio de sesión",
    "dashboard.today": "hoy",
    "dashboard.range7d": "7D",
    "dashboard.range30d": "30D",
    "dashboard.range90d": "90D",
    "dashboard.range1y": "1 año",
    "dashboard.rangeAll": "Todos",
    "dashboard.income": "Ingresos",
    "dashboard.liveReleases": "Lanzamientos en vivo",
    "dashboard.last30days": "últimos 30 días",
    "dashboard.liveStreamingMap": "Mapa de transmisión en vivo",
    "dashboard.live": "en vivo",
    "dashboard.noDataYet": "Aún no hay datos",
    "dashboard.streams": "corrientes",
    "dashboard.wentLive": "fue en vivo",
    "dashboard.rejected": "Rechazado",
    "dashboard.inReview": "En revisión",
    "dashboard.revenueAnalysis": "Análisis de Ingresos",
    "dashboard.platformFilter": "Filtro de Plataforma",
    "dashboard.totalRevenue": "Ingresos Totales",
    
    // Layout
    "layout.profile": "Perfil",
    "layout.subscription": "Suscripción",
    "layout.logout": "Cerrar sesión",
    
    // QR Code Generator
    "qr.title": "Generador de códigos QR",
    "qr.create": "Crear código QR",
    "qr.createTitle": "Nuevo código QR",
    "qr.url": "URL",
    "qr.qrTitle": "Título",
    "qr.fgColor": "Color de primer plano",
    "qr.bgColor": "Color de fondo",
    "qr.size": "Tamaño",
    "qr.small": "pequeño",
    "qr.medium": "Medio",
    "qr.large": "Grande",
    "qr.download": "Descargar",
    "qr.delete": "Eliminar",
    "qr.scanCount": "Escaneos",
    "qr.empty": "Aún no hay códigos QR",
    "qr.emptyDesc": "Crea tu primer código QR para comenzar.",
    
    // Smart Links
    "smartLinks.title": "Enlaces Inteligentes",
    "smartLinks.subtitle": "Crea páginas de redirección inteligentes para tu música",
    "smartLinks.createBtn": "Crear Enlace Inteligente",
    "smartLinks.cover": "Portada",
    "smartLinks.backgroundImage": "Imagen de Fondo",
    "smartLinks.cancel": "Cancelar",
    "smartLinks.create": "Crear enlace inteligente",
    "smartLinks.linkTitle": "Título",
    "smartLinks.slug": "Slug de URL personalizado",
    "smartLinks.platforms": "Enlaces de plataforma",
    "smartLinks.clicks": "Clics",
    "smartLinks.copy": "Copiar enlace",
    "smartLinks.copied": "¡Copiado!",
    "smartLinks.empty": "Aún no hay enlaces inteligentes",
    "smartLinks.emptyDesc": "Crea tu primer enlace inteligente para compartir tu música.",
    
    // Pre-Save Campaign
    "preSave.title": "Campañas de Pre-Save",
    "preSave.subtitle": "Crea campañas de pre-save para tus próximos lanzamientos",
    "preSave.createNew": "Nueva Campaña",
    "preSave.createBtn": "Crear Campaña",
    "preSave.descPlaceholder": "Descripción de la campaña...",
    "preSave.backgroundImage": "Imagen de Fondo",
    "preSave.uploadBg": "Subir Fondo",
    "preSave.bgHint": "Recomendado: imagen horizontal de 1920x1080px",
    "preSave.cancel": "Cancelar",
    "preSave.all": "Todos",
    "preSave.pending": "Pendiente",
    "preSave.approved": "Aprobado",
    "preSave.rejected": "Rechazado",
    "preSave.create": "Crear campaña",
    "preSave.selectRelease": "Seleccionar lanzamiento",
    "preSave.releaseDate": "Fecha de lanzamiento",
    "preSave.description": "Descripción",
    "preSave.saves": "Guarda",
    "preSave.daysLeft": "quedan días",
    "preSave.released": "liberado",
    "preSave.active": "Activo",
    "preSave.copy": "Copiar enlace",
    "preSave.empty": "Aún no hay campañas guardadas previamente",
    "preSave.emptyDesc": "Cree una campaña de guardado previo para su próximo lanzamiento.",
    
    // Email Marketing
    "email.title": "Marketing por correo electrónico",
    "email.subscribers": "Suscriptores",
    "email.campaigns": "Campañas",
    "email.addSubscriber": "Agregar suscriptor",
    "email.name": "Nombre",
    "email.emailAddr": "Dirección de correo electrónico",
    "email.subject": "Asunto",
    "email.template": "Plantilla",
    "email.content": "Contenido",
    "email.send": "enviar",
    "email.draft": "Borrador",
    "email.sent": "Enviado",
    "email.opened": "Abierto",
    "email.clicked": "Se hizo clic",
    "email.import": "Importar CSV",
    "email.export": "Exportar CSV",
    "email.empty": "Aún no hay datos",
    "email.totalSubscribers": "Suscriptores totales",
    
    // Social Media Scheduler
    "social.title": "Programador de redes sociales",
    "social.newPost": "Nueva publicación",
    "social.content": "Contenido",
    "social.platforms": "Plataformas",
    "social.schedule": "Horario",
    "social.draft": "Borrador",
    "social.scheduled": "Programado",
    "social.published": "Publicado",
    "social.edit": "Editar",
    "social.delete": "Eliminar",
    "social.calendar": "Calendario",
    "social.list": "Lista",
    "social.empty": "Aún no hay publicaciones",
    "social.emptyDesc": "Planifica y programa tus publicaciones en las redes sociales.",
    
    // Press Kit
    "pressKit.title": "Carpeta de prensa (EPK)",
    "pressKit.bio": "Biografía",
    "pressKit.photos": "Fotos",
    "pressKit.discography": "Discografía",
    "pressKit.social": "Enlaces sociales",
    "pressKit.contact": "Información de contacto",
    "pressKit.save": "Guardar kit de prensa",
    "pressKit.preview": "Vista previa",
    "pressKit.publicUrl": "URL pública",
    "pressKit.empty": "Su kit de prensa está vacío",
    
    // Lyrics Sync
    "lyricsSync.title": "Sincronización de Letras",
    "lyricsSync.subtitle": "Crea letras sincronizadas para tus canciones",
    "lyricsSync.lyricsEditor": "Editor de Letras",
    "lyricsSync.resetTimestamps": "Restablecer Tiempos",
    "lyricsSync.tapToSync": "Toca para Sincronizar",
    "lyricsSync.timestamps": "Marcas de Tiempo",
    "lyricsSync.save": "Guardar Letras",
    "lyricsSync.synced": "Sincronizado",
    "lyricsSync.selectTrack": "Seleccionar pista",
    "lyricsSync.lyrics": "Letras",
    "lyricsSync.sync": "Sincronizar",
    "lyricsSync.tap": "Toca para sincronizar",
    "lyricsSync.preview": "Vista previa",
    "lyricsSync.export": "Exportar LRC",
    "lyricsSync.save": "Guardar",
    "lyricsSync.empty": "Selecciona una pista para comenzar",
    
    // Collaborations
    "collab.title": "Colaboraciones",
    "collab.subtitle": "Invita a otros artistas y colabora en proyectos",
    "collab.received": "Recibidas",
    "collab.sent": "Enviadas",
    "collab.reject": "Rechazar",
    "collab.create": "Nuevo proyecto",
    "collab.invite": "Invitar",
    "collab.projects": "Mis proyectos",
    "collab.invitations": "Invitaciones",
    "collab.accept": "Aceptar",
    "collab.decline": "Rechazar",
    "collab.notes": "Notas",
    "collab.status": "Estado",
    "collab.empty": "Aún no hay colaboraciones",
    "collab.emptyDesc": "Iniciar un proyecto de colaboración con otros artistas.",
    "collab.send_invite": "Invitar Artista",
    "collab.email": "Buscar por nombre o email",
    "collab.type": "Tipo de Colaboración",
    "collab.type_featured": "Feat. Artista",
    "collab.type_producer": "Productor",
    "collab.type_writer": "Compositor",
    "collab.type_remix": "Remix",
    "collab.message": "Mensaje",
    "collab.send": "Enviar Invitación",
    "collab.no_received": "Aún no hay colaboraciones",
    "collab.no_sent": "Aún no hay colaboraciones",
    "collab.invite_success": "¡Invitación enviada con éxito!",
    "collab.invite_error": "No se pudo enviar la invitación",
    "collab.accepted": "Aceptado",
    "collab.rejected": "Rechazado",
    "collab.respond_error": "No se pudo responder a la invitación",
    "collab.delete_confirm": "¿Estás seguro de que quieres eliminar esto?",
    "collab.delete_success": "Colaboración eliminada",
    "collab.delete_error": "No se pudo eliminar la colaboración",
    "collab.error_fetch": "No se pudieron cargar las colaboraciones",
    "collab.status_accepted": "Activo",
    "collab.status_rejected": "Rechazado",
    "collab.status_pending": "Pendiente",
    
    // Notification translations

    "notif.release_status.title": "Actualización de Estado",
    "notif.release_status.approved.title": "Lanzamiento Aprobado",
    "notif.release_status.approved.message": "Tu lanzamiento ha sido aprobado.",
    "notif.release_status.rejected.title": "Lanzamiento Rechazado",
    "notif.release_status.rejected.message": "Tu lanzamiento ha sido rechazado.",
    "notif.release_status.live.title": "Lanzamiento Activo",
    "notif.release_status.live.message": "Tu lanzamiento está activo.",
    "notif.release_status.needs_edits.title": "Edición Requerida",
    "notif.release_status.needs_edits.message": "Tu lanzamiento necesita algunas ediciones antes de ser aprobado.",
    "notif.release_status.in_review.title": "En Revisión",
    "notif.release_status.in_review.message": "Tu lanzamiento está siendo revisado.",
    "notif.release_status.taken_down.title": "Lanzamiento Retirado",
    "notif.release_status.taken_down.message": "Tu lanzamiento ha sido retirado.",
    "notif.release_deleted.title": "Lanzamiento Eliminado",
    "notif.release_deleted.message": "Un lanzamiento ha sido eliminado.",
    "notif.account_status.title": "Estado de Cuenta",
    "notif.account_status.approved.title": "Cuenta Aprobada",
    "notif.account_status.rejected.title": "Cuenta Rechazada",
    "notif.referral_bonus.title": "¡Bono de Referencia Recibido!",
    "notif.referral_bonus.message": "Recibiste un bono de referencia.",
    "notif.payout_status.title": "Actualización de Pago",
    "notif.payout_status.approved.title": "Pago Aprobado",
    "notif.payout_status.rejected.title": "Pago Rechazado",
    "notif.payout_status.completed.title": "Pago Completado",
    "notif.payout_status.message": "Tu solicitud de pago ha sido actualizada.",
    "notif.ticket_reply.title": "Nueva Respuesta de Soporte",
    "notif.ticket_reply.message": "Tienes una nueva respuesta en tu ticket de soporte.",
    "notif.announcement.title": "Nuevo Anuncio",
    "notif.spotify_linked.title": "Perfil de Spotify Vinculado",
    "notif.spotify_linked.message": "Tu perfil de artista ha sido vinculado a Spotify. Las estadísticas ya están disponibles.",
    "notif.artist_needs_spotify.title": "Artista Necesita Vinculación de Spotify",
    "notif.split_response.title": "Respuesta de Split",
    "notif.split_response.accepted": "aceptó",
    "notif.split_response.rejected": "rechazó",
    "notif.revenue_added.title": "Ingreso Agregado",
    "notif.kyc_submission.title": "Nueva Solicitud KYC",
    "notif.kyc_review.title": "Verificación de Identidad",
    "notif.kyc_review.approved.message": "¡Tu verificación de identidad ha sido aprobada!",
    "notif.kyc_review.rejected.message": "Tu verificación de identidad fue rechazada.",
    "notif.playlist_campaign.title": "Nueva Solicitud de Playlist",
    "notif.playlist_campaign_approved.title": "Solicitud de Playlist Aprobada",
    "notif.playlist_campaign_approved.message": "Tu solicitud de playlist ha sido aprobada.",
    "notif.playlist_campaign_rejected.title": "Solicitud de Playlist Rechazada",
    "notif.playlist_campaign_rejected.message": "Tu solicitud de playlist ha sido rechazada.",
    "notif.reason": "Razón",

        // Fan Engagement
    "fanScore.title": "Compromiso de los fans",
    "fanScore.subtitle": "Realice un seguimiento de las métricas de crecimiento y participación de su audiencia",
    "fanScore.overall": "Puntuación general",
    "fanScore.streaming": "Transmisión",
    "fanScore.social": "Alcance social",
    "fanScore.loyalty": "Lealtad de fans",
    "fanScore.activity": "Actividad de contenido",
    "fanScore.trend": "Tendencia Semanal",
    "fanScore.last12weeks": "Últimas 12 semanas",
    "fanScore.now": "Ahora",
    "fanScore.platforms": "Desglose de la plataforma",
    "fanScore.platformHint": "Puntuación por plataforma de streaming",
    "fanScore.tips": "Recomendaciones de IA",
    "fanScore.noData": "Aún no hay datos de participación disponibles.",
    "fanScore.noDataHint": "Publica música y haz crecer tu audiencia para ver tu partitura.",
    
    // Copyright Scan
    "copyright.title": "Escaneo de derechos de autor",
    "copyright.newScan": "Nuevo escaneo",
    "copyright.upload": "Cargar archivo",
    "copyright.selectTrack": "Seleccionar pista",
    "copyright.scanning": "Exploración...",
    "copyright.clean": "limpio",
    "copyright.warning": "Advertencia",
    "copyright.flagged": "Marcado",
    "copyright.matches": "Partidos",
    "copyright.similarity": "Similitud",
    "copyright.empty": "Aún no hay escaneos",
    "copyright.emptyDesc": "Escanee sus pistas en busca de posibles problemas de derechos de autor.",
    
    // Releases
    "releases.title": "Lanzamientos",
    "releases.createNew": "Nuevo Lanzamiento",
    "releases.noReleases": "Sin lanzamientos aún",
    "releases.searchPlaceholder": "Buscar lanzamientos...",
    "releases.localTime": "Local",
    "releases.globalTime": "Global",
    "releases.records": "registros",
    "releases.allReleases": "Todos los Lanzamientos",
    "releases.drafts": "Borradores",
    "releases.filter": "Filtrar",
    "releases.sort": "Ordenar",
    "releases.newest": "Más Reciente",
    "releases.oldest": "Más Antiguo",
    "releases.nameAZ": "Nombre (A-Z)",
    "releases.nameZA": "Nombre (Z-A)",
    "releases.inReview": "En Revisión",
    "releases.approved": "Aprobados",
    "releases.scheduled": "Programados",
    "releases.live": "En Vivo",
    "releases.tableTitle": "Título",
    "releases.tableTracks": "Pistas",
    "releases.tableArtist": "Artista",
    "releases.tableLastUpdate": "Última Actualización",
    "releases.tableProgress": "Progreso",
    "releases.tableActions": "Acciones",
    "releases.releaseDate": "Fecha de Lanzamiento",
    "releases.untitled": "Lanzamiento Sin Título",
    
    // Analytics
    "analytics.title": "Estadísticas",
    "analytics.subtitle": "Sigue el rendimiento de tus lanzamientos",
    "analytics.totalStreams": "Reproducciones Totales",
    "analytics.listeners": "Oyentes",
    "analytics.estimatedEarnings": "Ganancias Estimadas",
    "analytics.monthlyGrowth": "Crecimiento Mensual",
    "analytics.streamsChart": "Gráfico de Reproducciones",
    "analytics.platformDistribution": "Distribución por Plataforma",
    "analytics.topTracks": "Pistas Más Populares",
    "analytics.trackName": "Nombre de Pista",
    "analytics.streams": "reproducciones",
    "analytics.comingSoonTitle": "Muy Pronto",
    "analytics.comingSoonDesc": "Análisis detallados y estadísticas estarán disponibles pronto. Con la integración de artist.tools, podrás seguir todos los datos de tus plataformas en un solo lugar.",
    "analytics.performance": "Rendimiento",
    "analytics.noDataTitle": "Aún no hay datos analíticos",
    "analytics.noDataDesc": "Una vez que se realice un seguimiento de sus lanzamientos en YouTube o Spotify, sus estadísticas aparecerán aquí.",
    "analytics.contactAdmin": "Comuníquese con el administrador para vincular sus videos de YouTube o su perfil de artista de Spotify.",
    "analytics.totalViews": "Vistas totales",
    "analytics.totalLikes": "Me gusta totales",
    "analytics.totalComments": "Comentarios totales",
    "analytics.trackedVideos": "Vídeos rastreados",
    "analytics.daily": "Diariamente",
    "analytics.weekly": "Semanal",
    "analytics.topVideos": "Vídeos con mejor rendimiento",
    "analytics.totalFollowers": "Seguidores totales",
    "analytics.monthlyListeners": "Oyentes mensuales",
    "analytics.linkedArtists": "Artistas vinculados",
    "analytics.avgPopularity": "Popularidad promedio",
    "analytics.linkedSpotifyArtists": "Artistas de Spotify vinculados",
    "analytics.followers": "seguidores",
    "analytics.popularity": "popularidad",
    "analytics.advancedTitle": "Análisis avanzado próximamente",
    "analytics.advancedDesc": "Próximamente estarán disponibles recuentos detallados de transmisiones, distribución geográfica y análisis de ingresos.",
    
    // Payouts
    "payouts.title": "Gestiona Tus Ganancias",
    "payouts.subtitle": "Retira fácilmente tus ganancias musicales. Solicita un pago con un mínimo de $50.",
    "payouts.fastPayment": "Pago rápido",
    "payouts.secureTransfer": "Transferencia segura",
    "payouts.totalBalance": "Saldo Total",
    "payouts.withdrawableBalance": "Disponible para Retiro",
    "payouts.requestPayout": "Solicitar Pago",
    "payouts.payoutHistory": "Historial de Pagos",
    "payouts.noPayouts": "Sin solicitudes de pago aún",
    "payouts.noPaymentMethod": "Sin Método de Pago",
    "payouts.addMethodDesc": "Agrega un método de pago para retirar tus ganancias.",
    "payouts.addMethod": "Agregar Método de Pago",
    "payouts.changeMethodVerification": "Se requiere verificación por correo para cambiar tu método de pago actual",
    "payouts.availableBalance": "Saldo Disponible",
    "payouts.pendingBalance": "Saldo Pendiente",
    "payouts.withdrawalHistory": "Historial de Retiros",
    "payouts.requestWithdrawal": "Solicitar Retiro",
    "payouts.minWithdrawal": "Retiro mínimo: $50",
    "payouts.tabProfile": "Perfil de Pago",
    "payouts.tabMethod": "Método de Pago",
    "payouts.tabRequests": "Solicitudes de Retiro",
    "payouts.requirements": "Requisitos para Retiro",
    "payouts.completeProfile": "Completa tu perfil de pago (Identidad y Dirección)",
    "payouts.addPaymentMethod": "Agrega un método de pago (Banco o PayPal)",
    "payouts.verifyPaymentMethod": "Verifica tu método de pago",
    "payouts.profileComplete": "Completado",
    "payouts.savedProfile": "Información de Perfil Guardada",
    "payouts.fullName": "Nombre Completo",
    "payouts.phoneNumber": "Teléfono",
    "payouts.location": "Ubicación",
    "payouts.profileType": "Tipo de Perfil",
    "payouts.individual": "Individual",
    "payouts.business": "Empresa / Negocio",
    "payouts.edit": "Editar",
    "payouts.firstName": "Nombre",
    "payouts.lastName": "Apellido",
    "payouts.displayName": "Nombre de artista",
    "payouts.companyName": "Nombre de empresa",
    "payouts.selectCountry": "Selecciona tu país",
    "payouts.saveProfile": "Guardar Perfil",
    "payouts.saving": "Guardando...",
    "payouts.changeMethod": "Cambiar Método de Pago",
    "payouts.phoneRequired": "El número de teléfono es obligatorio",
    "payouts.operationFailed": "Operación fallida",
    "payouts.verificationSent": "Código de verificación enviado a tu correo",
    "payouts.maxAttemptsReached": "Máximo de intentos alcanzado. Por favor solicita un nuevo código.",
    "payouts.methodUpdated": "Tu método de pago ha sido actualizado exitosamente",
    "payouts.verificationFailed": "Verificación fallida",
    "payouts.newCodeSent": "Nuevo código de verificación enviado",
    "payouts.codeSendFailed": "Error al enviar el código",
    "payouts.weeklyLimitReached": "Has alcanzado tu límite semanal de retiros (2/2). Por favor intenta la próxima semana.",
    "payouts.profileMethodRequired": "El perfil y método de pago deben estar completos para solicitar un retiro",
    "payouts.requestCreated": "Solicitud de pago creada",
    "payouts.requestFailed": "Solicitud fallida",
    "payouts.methodSaved": "Método de pago guardado",
    "payouts.methodDeleted": "Método de pago eliminado",
    "payouts.paymentComplete": "Tu pago ha sido completado",
    "payouts.paymentApproved": "Tu pago ha sido aprobado",
    "payouts.transferComplete": "Transferencia completada exitosamente",
    "payouts.bankAccount": "Cuenta Bancaria",
    "payouts.ibanSwift": "IBAN / Swift",
    "payouts.accountNumber": "Número de Cuenta",
    "payouts.enterAccountNumber": "Ingresa el número de cuenta",
    "payouts.securityNotice": "Aviso de Seguridad",
    "payouts.securityNoticeDesc": "Todos los cambios en tu método de pago requieren verificación por correo electrónico (válido por 2 minutos). Solo puedes guardar un método de pago.",
    "payouts.completeProfileFirst": "Completa el Perfil Primero",
    "payouts.completeProfileFirstDesc": "Necesitas completar tu perfil de pago antes de agregar un método de pago.",
    "payouts.completeProfileBtn": "Completar Perfil",
    "payouts.requirementsNotMet": "Requisitos no cumplidos",
    "payouts.minBalanceRequired": "Se requiere un saldo mínimo de $50 para retirar.",
    "payouts.completeProfileRequired": "Completa tu perfil de pago.",
    "payouts.addVerifyMethodRequired": "Agrega y verifica tu método de pago.",
    "payouts.weeklyWithdrawalLimit": "Límite Semanal de Retiros",
    "payouts.withdrawalsMadeThisWeek": "Esta semana {count} / 2 retiros realizados",
    "payouts.weeklyLimitReachedMsg": "Has alcanzado tu límite semanal de retiros. Podrás retirar nuevamente la próxima semana.",
    "payouts.verified": "Verificado",
    "payouts.pendingVerification": "Verificación Pendiente",
    "payouts.change": "Cambiar",
    "payouts.changePaymentMethod": "Cambiar Método de Pago",
    "payouts.addPaymentMethod": "Agrega un método de pago (Banco o PayPal)",
    "payouts.deletePaymentMethod": "Eliminar Método de Pago",
    "payouts.deleteMethodConfirm": "¿Estás seguro de que deseas eliminar este método de pago? Esta acción no se puede deshacer.",
    "payouts.cancel": "Cancelar",
    "payouts.identityInfo": "Información de Identidad",
    "payouts.identityInfoDesc": "Tu información de identidad legal se utilizará para facturación y cumplimiento de pagos",
    "payouts.profileTypeLabel": "Tipo de Perfil",
    "payouts.individualOption": "Individual",
    "payouts.individualOptionDesc": "Obtengo ingresos como persona física",
    "payouts.businessOption": "Empresa / Compañía",
    "payouts.businessOptionDesc": "Obtengo ingresos en nombre de una empresa",
    "payouts.companyInfo": "Información de la Empresa",
    "payouts.companyTitle": "Nombre de la Empresa",
    "payouts.registrationNumber": "Número de Registro Comercial",
    "payouts.vatNumber": "Número de IVA/Impuesto",
    "payouts.legalFirstName": "Nombre Legal",
    "payouts.legalLastName": "Apellido Legal",
    "payouts.displayNameOptional": "Nombre Artístico (Opcional)",
    "payouts.email": "Correo (Correo de la Cuenta)",
    "payouts.emailChangeNote": "El correo se puede cambiar desde la configuración de la cuenta",
    "payouts.addressInfo": "Información de Dirección",
    "payouts.country": "País",
    "payouts.city": "Ciudad",
    "payouts.stateOptional": "Estado/Región (Opcional)",
    "payouts.postalCode": "Código Postal",
    "payouts.addressLine1": "Línea de Dirección 1",
    "payouts.addressLine2Optional": "Línea de Dirección 2 (Opcional)",
    "payouts.taxInfo": "Información Fiscal",
    "payouts.taxRequired": "Requerido para retiros",
    "payouts.taxInfoDesc": "Debes completar tu información fiscal para solicitar un retiro",
    "payouts.taxStatus": "Estado Fiscal",
    "payouts.taxStatusPersonal": "Número de identificación personal",
    "payouts.taxStatusCompany": "Empresa / Número de Identificación Fiscal",
    "payouts.taxStatusRequired": "Debes seleccionar un estado fiscal para solicitar un retiro",
    "payouts.taxIdCompany": "Número de Identificación Fiscal",
    "payouts.taxIdPersonal": "Número de Identificación Personal",
    "payouts.taxCountry": "País Fiscal",
    "payouts.savedTaxId": "Registrado",
    "payouts.fullAddress": "Dirección Completa",
    "payouts.taxInfoDisplay": "Información Fiscal",
    "payouts.companyTax": "Empresa",
    "payouts.personalTax": "Individual",
    "payouts.profileIncomplete": "Perfil Incompleto",
    "payouts.profileIncompleteDesc": "Por favor completa los campos obligatorios",
    "payouts.paymentCurrency": "Moneda de Pago",
    "payouts.paymentCurrencyDesc": "Selecciona en qué moneda deseas recibir los pagos",
    "payouts.paypalEmailRequired": "Correo de PayPal",
    "payouts.paymentToAccount": "Cuenta de Pago",
    "payouts.requestRejected": "Tu solicitud de retiro fue rechazada",
    "payouts.rejectionReason": "Razón",
    "payouts.paymentCompleteMsg": "Tu pago ha sido completado",
    "payouts.paymentApprovedMsg": "Tu pago ha sido aprobado",
    "payouts.transferCompleteMsg": "Transferencia completada exitosamente",
    "payouts.paymentInProgress": "Llegará a tu banco en 2-3 días hábiles",
    "payouts.nameAndSurnameRequired": "Nombre y apellido son obligatorios",
    "payouts.addressRequired": "La información de dirección es obligatoria (País, Ciudad, Código Postal, Dirección)",
    "payouts.profileSaved": "Perfil de pago guardado",
    "payouts.profileSaveFailed": "No se pudo guardar el perfil",
    "payouts.accountHolderCountryRequired": "Nombre del titular de la cuenta y país son obligatorios",
    "payouts.bankNameRequired": "El nombre del banco es obligatorio",
    "payouts.swiftRequired": "El código SWIFT/BIC es obligatorio",
    "payouts.ibanRequired": "El IBAN es obligatorio",
    "payouts.accountNumberRequired": "El número de cuenta es obligatorio",
    "payouts.paypalEmailRequiredMsg": "El correo de PayPal es obligatorio",
    "payouts.withdrawRequestFailed": "El perfil y método de pago deben estar completos para solicitar un retiro",
    "payouts.minWithdrawalAmount": "El monto mínimo de retiro es $50",
    "payouts.insufficientBalanceMsg": "Saldo insuficiente",
    "payouts.withdrawRequestCreated": "Solicitud de retiro creada",
    "payouts.withdrawRequestFailedMsg": "La solicitud de retiro falló",
    "payouts.enterVerificationCode": "Ingresa el código de verificación de 6 dígitos",
    "payouts.selectCountryPlaceholder": "Selecciona un país",
    
    // Wizard extras
    "wizard.editRelease": "Editar Lanzamiento",
    "wizard.newSingleRelease": "Nuevo Single",
    "wizard.completeSectionsToSubmit": "Completa todas las secciones para enviar tu lanzamiento",
    "wizard.editAlbum": "Editar Álbum",
    "wizard.newEpAlbum": "Nuevo EP / Álbum",
    "wizard.completeSectionsToSubmitAlbum": "Completa todas las secciones para enviar tu álbum",
    "wizard.sections.albumInfo": "Información del Álbum",
    "wizard.sections.tracks": "Pistas",
    "wizard.sections.releaseSettings": "Configuración del Lanzamiento",
    "wizard.sections.moreOptions": "Más Opciones",
    "wizard.sections.review": "Revisar",
    "wizard.selectPRO": "Selecciona PRO",
    
    // Album wizard specific
    "wizard.album.title": "Título del Álbum",
    "wizard.album.titlePlaceholder": "Ingresa el título del álbum",
    "wizard.album.titleRequired": "El título del álbum es obligatorio",
    "wizard.album.titleLanguage": "Idioma del Título",
    "wizard.album.version": "Versión",
    "wizard.album.versionPlaceholder": "ej., Edición Deluxe",
    "wizard.album.primaryGenre": "Género Principal",
    "wizard.album.subGenre": "Subgénero",
    "wizard.album.selectGenre": "Selecciona género",
    "wizard.album.selectSubGenre": "Primero selecciona el género principal",
    "wizard.album.genreRequired": "El género principal es obligatorio",
    "wizard.album.primaryArtists": "Artistas Principales",
    "wizard.album.addArtist": "Añadir artista",
    "wizard.album.artistRequired": "Se requiere al menos un artista principal",
    "wizard.album.recordLabel": "Sello Discográfico",
    "wizard.album.recordLabelPlaceholder": "Nombre del sello (opcional)",
    "wizard.album.coverArt": "Portada",
    "wizard.album.coverRequired": "La portada es obligatoria",
    "wizard.album.coverRequirements": "Requisitos de Portada",
    "wizard.album.squareFormat": "Formato cuadrado (proporción 1:1)",
    "wizard.album.minResolution": "Mínimo 1400x1400 píxeles (3000x3000 recomendado)",
    "wizard.album.maxFileSize": "Máximo 20MB",
    "wizard.album.jpgPng": "Formato JPG o PNG",
    "wizard.album.uploadCover": "Subir Portada",
    "wizard.album.uploading": "Subiendo...",
    "wizard.album.distribution": "Distribución",
    "wizard.album.newRelease": "Nuevo Lanzamiento",
    "wizard.album.newReleaseDesc": "Este es un lanzamiento completamente nuevo",
    "wizard.album.transfer": "Transferir de Otro Distribuidor / Previamente Lanzado",
    "wizard.album.transferDesc": "Este contenido fue lanzado anteriormente a través de otro distribuidor",
    "wizard.album.existingUpc": "Código UPC Existente",
    "wizard.album.upcPlaceholder": "Ingresa el UPC existente",
    "wizard.album.originalReleaseDate": "Fecha de Lanzamiento Original",
    "wizard.album.minTracks": "EP/Álbum requiere al menos 2 pistas",
    "wizard.album.addTrack": "Añadir Pista",
    "wizard.album.untitled": "Álbum Sin Título",
    "wizard.album.errorsFound": "Errores Encontrados",
    "wizard.album.fixErrors": "Corregir Errores",
    "wizard.album.readyToSubmit": "Álbum Listo para Enviar",
    "wizard.album.allComplete": "Todas las secciones están completas. Tu álbum está listo para revisión.",
    "wizard.album.submitAlbum": "Enviar Álbum",
    "wizard.album.saveDraft": "Guardar Borrador",
    "wizard.album.errorsDetected": "Errores Detectados",
    "wizard.album.fixBeforeSubmit": "Debes corregir los siguientes errores antes de enviar tu álbum:",
    "wizard.album.loadFailed": "Error al cargar álbum",
    "wizard.album.distributionPlatforms": "Plataformas de Distribución",
    
    // Track related
    "wizard.track.title": "Título de la Pista",
    "wizard.track.titlePlaceholder": "Ingresa el título de la pista",
    "wizard.track.titleRequired": "El título de la pista es obligatorio",
    "wizard.track.titleLanguage": "Idioma del Título",
    "wizard.track.trackLanguage": "Idioma de la Pista",
    "wizard.track.languageDesc": "Idioma de la letra o vocales",
    "wizard.track.version": "Versión",
    "wizard.track.versionPlaceholder": "ej., Edición Deluxe, Acústica, Remix",
    "wizard.track.versionDesc": "Info de versión: Acústica, En Vivo, Remix",
    "wizard.track.primaryGenre": "Género Principal",
    "wizard.track.subGenre": "Subgénero",
    "wizard.track.primaryArtists": "Artistas Principales",
    "wizard.track.featuredArtists": "Artistas Invitados",
    "wizard.track.add": "Añadir",
    "wizard.track.explicit": "Contenido Explícito",
    "wizard.track.explicitNone": "Ninguno",
    "wizard.track.explicitYes": "Sí, contiene contenido explícito",
    "wizard.track.explicitCleaned": "Versión limpia",
    "wizard.track.isRadioEdit": "Edición de Radio",
    "wizard.track.radioEditDesc": "Acortada o editada para radio",
    "wizard.track.instrumental": "Instrumental",
    "wizard.track.instrumentalDesc": "Sin vocales",
    "wizard.track.isrcCode": "Código ISRC",
    "wizard.track.useExistingIsrc": "Usar código ISRC existente",
    "wizard.track.isrcPlaceholder": "ej., USRC11234567",
    "wizard.track.audioFile": "Archivo de Audio",
    "wizard.track.audioRequired": "El archivo de audio es obligatorio",
    "wizard.track.uploadAudio": "Subir Archivo de Audio",
    "wizard.track.audioFormats": "WAV o FLAC • 44.1-96kHz • 16/24 bit",
    "wizard.track.recordLabel": "Sello Discográfico",
    "wizard.track.albumRecordLabel": "Se usa el mismo sello en todo el álbum. Cámbialo en la pista 1.",
    "wizard.track.credits": "Créditos",
    "wizard.track.songwriters": "Compositores",
    "wizard.track.addSongwriter": "Añadir Compositor",
    "wizard.track.role": "Rol",
    "wizard.track.name": "Nombre",
    "wizard.track.composer": "Compositor",
    "wizard.track.lyricist": "Letrista",
    "wizard.track.composerLyricist": "Compositor y Letrista",
    "wizard.track.contributors": "Colaboradores",
    "wizard.track.addContributor": "Añadir Colaborador",
    "wizard.track.productionTeam": "Equipo de Producción",
    "wizard.track.addProduction": "Añadir Crédito de Producción",
    "wizard.track.lyrics": "Letra",
    "wizard.track.lyricsLanguage": "Idioma de la Pista (Language of Lyrics)",
    "wizard.track.lyricsPlaceholder": "Escribe la letra aquí...",
    "wizard.track.lyricsOptional": "Letra (Opcional)",
    "wizard.track.lyricsDesc": "La letra puede mostrarse en DSPs (Apple Music, Spotify, etc.)",
    "wizard.track.licenseRequired": "Documento de Licencia Requerido",
    "wizard.track.licenseRequiredDesc": "Debes proporcionar un documento de licencia para contenido con samples, remixes o material de terceros.",
    "wizard.track.uploadLicense": "Subir Documento de Licencia",
    "wizard.track.licenseUploaded": "PDF • Subido",
    "wizard.track.unknownArtist": "Artista Desconocido",
    
    // Review section
    "wizard.review.summary": "Resumen de Revisión",
    "wizard.review.errorsFound": "Errores Encontrados",
    "wizard.review.fixErrors": "Corregir Errores",
    "wizard.review.readyToSubmit": "Listo para Enviar",
    "wizard.review.allComplete": "Todas las secciones están completas. Tu lanzamiento está listo para revisión.",
    
    // Common wizard
    "wizard.next": "Siguiente",
    "wizard.back": "Atrás",
    "wizard.previous": "Anterior",
    "wizard.saveDraft": "Guardar Borrador",
    "wizard.submitRelease": "Enviar comunicado",
    "wizard.fixLater": "Arreglar más tarde (guardar borrador)",
    "wizard.fixNow": "Reparar ahora",
    "wizard.errorsDetected": "{{count}} errores detectados",
    "wizard.fixErrorsBeforeSubmit": "Debe corregir los siguientes errores antes de enviar su versión:",
    "wizard.submit": "Enviar",
    "wizard.save": "Guardar",
    "wizard.cancel": "Cancelar",
    "wizard.delete": "Eliminar",
    "wizard.edit": "Editar",
    "wizard.loading": "Cargando...",
    "wizard.selectOption": "Selecciona una opción",
    
    // Release Settings Section
    "wizard.releaseSettings.streamingPlatforms": "Plataformas de transmisión",
    "wizard.releaseSettings.socialPlatforms": "Plataformas sociales",
    "wizard.releaseSettings.selectAll": "Seleccionar todo",
    "wizard.releaseSettings.selected": "seleccionado",
    "wizard.releaseSettings.timeSync": "Sincronización del tiempo de lanzamiento",
    "wizard.releaseSettings.timeSyncDesc": "Elige cómo se lanzará tu lanzamiento a nivel mundial",
    "wizard.releaseSettings.localTime": "Hora local (lanzamiento escalonado)",
    "wizard.releaseSettings.localTimeDesc": "Lanzamientos a medianoche (00:00) en cada región. Tu música se transmite a medida que cada zona horaria llega a la fecha de lanzamiento.",
    "wizard.releaseSettings.globalTime": "Hora global (lanzamiento simultáneo)",
    "wizard.releaseSettings.globalTimeDesc": "Lanzamientos al mismo tiempo en todo el mundo. Se activa en todas partes con una única marca de tiempo UTC.",
    "wizard.releaseSettings.releaseDate": "Fecha de lanzamiento",
    "wizard.releaseSettings.releaseDateRequired": "Fecha de lanzamiento *",
    "wizard.releaseSettings.releaseTime": "Hora de lanzamiento (UTC)",
    "wizard.releaseSettings.minDaysNotice": "Al menos 7 días a partir de hoy.",
    
    // More Options Section
    "wizard.moreOptions.publishingRights": "Derechos de publicación",
    "wizard.moreOptions.publishingQuestion": "¿Qué porcentaje de los derechos de publicación posee?",
    "wizard.moreOptions.pub100": "100% - Poseo todos los derechos de publicación",
    "wizard.moreOptions.pub0": "0% - No tengo derechos de publicación",
    "wizard.moreOptions.pubOther": "Otro porcentaje",
    "wizard.moreOptions.proQuestion": "¿Está registrado en un PRO/CMO?",
    "wizard.moreOptions.proAffiliation": "PRO / Sociedad Afiliada *",
    "wizard.moreOptions.ipiNumber": "Número IPI *",
    "wizard.moreOptions.ipiPlaceholder": "Introduce tu número IPI",
    "wizard.moreOptions.youtubeContentId": "Identificación de contenido de YouTube",
    "wizard.moreOptions.youtubeQuestion": "¿Quieres habilitar el ID de contenido de YouTube?",
    "wizard.moreOptions.youtubeYes": "Sí, habilita Content ID",
    "wizard.moreOptions.youtubeNo": "No, no habilitar",
    "wizard.moreOptions.youtubeDesc": "Content ID te permite monetizar tu música en YouTube cuando otros la usan en sus videos.",
    
    // Review Section
    "wizard.review.errorsFoundCount": "{{count}} errores encontrados",
    "wizard.review.fixBeforeSubmit": "Solucione los siguientes problemas antes de enviar:",
    "wizard.review.releaseReady": "Lanzamiento listo para enviar",
    "wizard.review.allFieldsComplete": "Todos los campos obligatorios han sido completados.",
    "wizard.review.genre": "Género",
    "wizard.review.content": "Contenido",
    "wizard.review.releaseDate": "Fecha de lanzamiento",
    "wizard.review.timeMode": "Modo de hora",
    "wizard.review.distribution": "Distribución",
    "wizard.review.platforms": "Plataformas",
    "wizard.review.distributionPlatforms": "Plataformas de distribución",
    "wizard.review.localStaggered": "Local (escalonado)",
    "wizard.review.global": "Mundial",
    "wizard.review.explicit": "Explícito",
    "wizard.review.clean": "limpio",
    "wizard.review.upcIsrcAssigned": "El administrador asignará los códigos UPC e ISRC después del envío.",
    "wizard.review.creditsSummary": "Resumen de créditos",
    "wizard.review.songwriters": "Compositores",
    "wizard.review.productionTeam": "Equipo de producción",
    "wizard.review.contributors": "Colaboradores",
    "wizard.review.licensedContent": "Contenido con licencia",
    "wizard.review.licensedContentYes": "Sí: contiene contenido con licencia",
    "wizard.review.licensedContentNo": "No: solo contenido original",
    "wizard.review.licenseDocUploaded": "Documento de licencia cargado",
    
    // More Options - YouTube confirmations
    "wizard.moreOptions.ownershipConfirmation": "Confirmo que poseo el 100% de los derechos de esta grabación y composición.",
    "wizard.moreOptions.contentIdTerms": "Acepto los términos y condiciones de YouTube Content ID.",
    
    // Additional wizard keys
    "wizard.track.track": "Seguimiento",
    "wizard.trackCount": "Conteo de pistas",
    "wizard.subgenre": "Subgénero",
    "wizard.track.creditInfo": "Información crediticia",
    "wizard.track.songwriterRequired": "Se requiere al menos un compositor",
    "wizard.track.productionRequired": "Se requiere al menos un miembro del equipo de producción.",
    
    // Review section - Publishing & YouTube
    "wizard.review.publishingRightsInfo": "Información sobre derechos de publicación",
    "wizard.review.ownership": "Propiedad",
    "wizard.review.publisher": "Editor",
    "wizard.review.youtubeContentIdEnabled": "ID de contenido de YouTube habilitado",
    "wizard.review.youtubeMonetizeDesc": "Tu música será monetizada en YouTube",
    "wizard.review.originalReleaseDate": "Fecha de lanzamiento original",
    "wizard.review.trackList": "Lista de pistas",
    "wizard.review.upcAssignedAfterSubmit": "El código UPC será asignado por el administrador después del envío.",
    "wizard.review.documentUploaded": "Documento subido:",
    "wizard.review.documentMissing": "Falta documento",
    
    // Release extras
    "release.untitledTrack": "Pista Sin Título",
    "release.unknownArtist": "Artista Desconocido",
    "release.artistNotSpecified": "Artista no especificado",
    
    // Common extras
    "common.draft": "Borrador",
    
    // Support
    "support.title": "¿Cómo Podemos Ayudarte?",
    "support.subtitle": "El equipo de EAM Music está aquí para responder tus preguntas. Crea una solicitud de soporte y te responderemos lo antes posible.",
    "support.responseTime": "Respuesta en 24 horas",
    "support.professional": "Soporte profesional",
    "support.tickets": "Tickets de Soporte",
    "support.createTicket": "Crear Ticket",
    "support.noTickets": "No hay tickets de soporte",
    
    // Referrals
    "referrals.title": "Programa de Referidos",
    "referrals.commission5": "Comisión del 5%",
    "referrals.lifetimeEarnings": "Ganancias de por vida",
    "referrals.copiedBtn": "Copiado",
    "referrals.copyBtn": "Copiar",
    "referrals.invitedUsersDesc": "Personas que trajiste a la plataforma y su estado",
    "referrals.subtitle": "Invita a tus amigos a EAM Music y gana 5% de comisión sobre sus ganancias.",
    "referrals.commission": "5% Comisión",
    "referrals.lifetime": "Ganancias de por vida",
    "referrals.totalInvites": "Total de Invitaciones",
    "referrals.activeReferrals": "Referidos Activos",
    "referrals.totalEarnings": "Ganancias Totales",
    "referrals.yourLink": "Tu Enlace",
    "referrals.yourCode": "Tu Código",
    "referrals.copy": "Copiar",
    "referrals.copied": "Copiado",
    "referrals.yourLink": "Tu Enlace",
    "referrals.link": "Enlace",
    "referrals.code": "Código",
    "referrals.invitedUsers": "Usuarios Invitados",
    "referrals.startSharing": "Comienza a compartir tu enlace",
    "referrals.registerDate": "Fecha de Registro",
    "referrals.active": "Activo",
    "referrals.commission": "5% Comisión",
    "referrals.lifetime": "Ganancias de por vida",
    "referrals.activeReferrals": "Referidos Activos",
    "referrals.commissionRate": "Tasa de Comisión",
    "referrals.totalReferrals": "Total de Referidos",
    "referrals.noReferrals": "Sin referidos aún",
    "referrals.howItWorksDesc": "Invita a otros artistas y gana el 5% de sus ganancias de por vida.",
    "referrals.pending": "Pendiente",
    
    // Releases
    "releases.myReleases": "Mis Lanzamientos",
    "releases.manageAll": "Gestiona todos tus lanzamientos",
    "releases.createNew": "Nuevo Lanzamiento",
    "releases.searchPlaceholder": "Buscar lanzamientos...",
    "releases.tracks": "pistas",
    "releases.noResults": "Sin resultados",
    "releases.tryDifferent": "Intenta cambiar tus criterios de búsqueda.",
    "releases.deleteDraft": "Eliminar Borrador",
    "releases.deleteDraftMsg": "Este borrador será eliminado permanentemente.",
    "releases.removeFromQueue": "Eliminar de la Cola de Revisión",
    "releases.removeFromQueueMsg": "Este lanzamiento será eliminado de la cola de revisión.",
    "releases.takedown": "Retirar Lanzamiento",
    "releases.takedownMsg": "⚠️ ATENCIÓN: Este lanzamiento será retirado de todas las tiendas.",
    "releases.delete": "Eliminar Lanzamiento",
    "releases.deleteMsg": "Este lanzamiento será eliminado.",
    "releases.yesRemove": "Sí, Eliminar",
    
    // Payouts
    "payouts.title": "Gestiona Tus Ganancias",
    "payouts.subtitle": "Retira fácilmente tus ganancias musicales. Solicita un pago con un mínimo de $50.",
    "payouts.fastPayment": "Pago rápido",
    "payouts.secureTransfer": "Transferencia segura",
    "payouts.manageEarnings": "Gestiona tus ganancias",
    "payouts.requestPayout": "Solicitar Pago",
    "payouts.createRequest": "Crear Solicitud de Pago",
    "payouts.amount": "Monto",
    "payouts.withdrawableBalance": "Disponible para Retiro",
    "payouts.accountHolder": "Nombre del Titular",
    "payouts.bankName": "Nombre del Banco",
    "payouts.totalBalance": "Saldo Total",
    "payouts.payoutHistory": "Historial de Pagos",
    "payouts.noPayouts": "Sin solicitudes de pago aún",
    "payouts.minAmount": "El monto mínimo de retiro es $50",
    "payouts.insufficientBalance": "Saldo insuficiente",
    "payouts.fillRequired": "Por favor completa todos los campos requeridos",
    "payouts.requestCreated": "Solicitud de pago creada",
    "payouts.requestFailed": "Solicitud fallida",
    "payouts.minNotMet": "Mínimo no alcanzado",
    "payouts.minNotMetMsg": "Necesitas al menos $50 de saldo disponible para solicitar un pago.",
    "payouts.statusRequested": "Solicitado",
    "payouts.statusPaid": "Pagado",
    "payouts.paymentMethod": "Método de Pago",
    "payouts.bankTransfer": "Transferencia Bancaria",
    "payouts.paypalEmail": "Correo de PayPal",
    "payouts.paypalNote": "Ingresa el correo asociado a tu cuenta de PayPal",
    "payouts.fillPaypalRequired": "Por favor ingresa el correo de PayPal y el nombre del titular",
    "payouts.selectCountry": "Selecciona tu país",
    
    // Support
    "support.title": "¿Cómo Podemos Ayudarte?",
    "support.subtitle": "El equipo de EAM Music está aquí para responder tus preguntas. Crea una solicitud de soporte y te responderemos lo antes posible.",
    "support.responseTime": "Respuesta en 24 horas",
    "support.professional": "Soporte profesional",
    "support.tickets": "Tickets de Soporte",
    "support.trackTickets": "Seguir Tickets",
    "support.createTicket": "Crear Ticket",
    "support.subject": "Asunto",
    "support.subjectPlaceholder": "Describe brevemente tu problema",
    "support.category": "Categoría",
    "support.message": "Mensaje",
    "support.messagePlaceholder": "Describe tu problema en detalle...",
    "support.noTickets": "No hay tickets de soporte",
    "support.fillAllFields": "Por favor completa todos los campos",
    "support.ticketCreated": "Ticket creado exitosamente",
    "support.ticketFailed": "Error al crear el ticket",
    "support.statusOpen": "Abierto",
    "support.statusPending": "Pendiente",
    "support.statusWaiting": "Esperando",
    "support.statusResolved": "Resuelto",
    "support.statusClosed": "Cerrado",
    "support.categoryRelease": "Lanzamientos",
    "support.categoryPayout": "Pagos",
    "support.categoryAccount": "Cuenta",
    "support.categoryTechnical": "Técnico",
    "support.priorityLow": "Bajo",
    "support.priorityMedium": "Medio",
    "support.priorityHigh": "Alto",
    
    // Track Upload
    "track.stepTitle": "Información de la Pista",
    "track.stepSubtitle": "Ingresa los detalles de tu pista",
    "track.songName": "Nombre de la canción",
    "track.enterSongName": "Ingresa el nombre de la canción",
    "track.uploadAfterName": "Sube el audio después de ingresar el nombre",
    "track.createAndContinue": "Crear y Continuar",
    "track.tracks": "pistas",
    "track.addTrack": "Agregar Pista",
    "track.bulkUploadTitle": "Subir Múltiples Pistas",
    "track.bulkUploadDesc": "Sube varios archivos de audio a la vez",
    "track.selectMultipleFiles": "Seleccionar Múltiples Archivos",
    "track.uploading": "Subiendo",
    "track.addOneByOne": "Agregar de Uno en Uno",
    "track.addSingleTrack": "Agregar Pista Individual",
    "track.addMoreFiles": "Agregar Más Archivos",
    "track.addManually": "Agregar Manualmente",
    "track.epAlbumSubtitle": "Crea un lanzamiento con múltiples pistas",
    "track.audioFormatInfo": "WAV o FLAC, mínimo 16-bit/44.1kHz",
    "track.audioRequired": "Archivo de audio requerido",
    "track.addTrackPrompt": "Agrega tu primera pista",
    "track.song": "canción",
    "track.trackName": "Nombre de la pista",
    "track.warnings": "Advertencias",
    "track.warning1": "No incluyas el nombre de los artistas invitados en el título",
    "track.warning2": "No uses información de versión entre paréntesis",
    "track.warning3": "Evita usar todas las letras en mayúsculas",
    "track.isrcCode": "Código ISRC",
    "track.isrcNote": "Si no tienes un código, crearemos uno para ti.",
    "track.audioFile": "Archivo de Audio",
    "track.uploading": "Subiendo",
    "track.uploadOrDrag": "Sube o arrastra archivo de audio",
    "track.selectFile": "Seleccionar Archivo",
    "track.contentType": "Tipo de Contenido",
    "track.clean": "Limpio",
    "track.explicit": "Explícito",
    "track.songPrice": "Precio de la canción – iTunes & Amazon (USD)",
    "track.priceNote": "Las canciones de más de 10 minutos tendrán un precio mayor.",
    "track.instrumental": "Esta pista es instrumental (sin letra)",
    "track.radioEdit": "Versión para Radio",
    "track.guestArtist": "Artista Invitado",
    "track.guestArtistNote": "Agrega artista invitado si aparece en la canción",
    "track.version": "Versión",
    "track.versionNote": "Información de versión como Acoustic, Live, Remix",
    
    // Track - Artists
    "track.primaryArtists": "Artistas Principales",
    "track.primaryArtistsNote": "Artista(s) principal(es) de esta pista",
    "track.addPrimaryArtist": "Agregar Artista Principal",
    "track.artistNamePlaceholder": "Nombre del artista",
    "track.featuredArtists": "Artistas Invitados",
    "track.featuredArtistsNote": "Artistas invitados (aparecerá como 'feat.')",
    "track.addFeaturedArtist": "Agregar Artista Invitado",
    "track.featuredArtistPlaceholder": "Nombre del artista invitado",
    "track.required": "Requerido",
    
    // Track - Previously Released
    "track.previouslyReleased": "¿Esta pista fue lanzada anteriormente?",
    "track.originalReleaseDate": "Fecha de Lanzamiento Original",
    "track.originalReleaseDateNote": "Ingresa la fecha cuando esta pista fue lanzada por primera vez",
    "track.preReleaseDate": "Fecha de Pre-lanzamiento",
    "track.preReleaseDateNote": "Establece una fecha para disponibilidad de pre-orden",
    
    // Track - Credits
    "track.creditsTitle": "Escritores, Compositores y Productores",
    "track.creditsRequired": "Requerido para las tiendas",
    "track.creditsWarning": "¡Las pistas no se pueden entregar sin al menos un escritor/compositor!",
    "track.writers": "Escritores / Compositores de letras",
    "track.writersPlaceholder": "John Doe, Jane Smith (separar con coma)",
    "track.writersNote": "Personas que escribieron las letras",
    "track.composers": "Compositores",
    "track.composersPlaceholder": "John Doe, Jane Smith (separar con coma)",
    "track.composersNote": "Personas que compusieron la música/melodía",
    "track.producers": "Productores",
    "track.producersPlaceholder": "Nombre del Productor (separar con coma)",
    "track.producersNote": "Personas que produjeron la pista",
    
    // Track - Lyrics
    "track.lyricsTitle": "Letras",
    "track.lyricsLanguage": "Idioma de las letras",
    "track.lyrics": "Letras",
    "track.lyricsPlaceholder": "Ingresa las letras de la canción aquí...",
    "track.lyricsNote": "Agregar letras puede ayudar a que tu canción sea descubierta",
    
    // Track - Licensed Content
    "track.licensedContent": "Esta pista contiene contenido con licencia (samples, beats, sonidos de stock, etc.)",
    "track.licensedContentNote": "Asegúrate de tener las licencias apropiadas para todo el contenido.",
    
    // Create Release Page
    "release.editTitle": "Editar Lanzamiento",
    "release.newTitle": "Nuevo Lanzamiento",
    "release.stepOf": "Paso {current} / {total}",
    "release.fetchError": "No se pudo obtener la información del lanzamiento",
    "release.saveError": "No se pudo guardar el lanzamiento",
    "release.statusChanged": "El estado del lanzamiento cambió a 'Necesita Ediciones'. Deberás volver a enviar después de completar tus cambios.",
    "release.addTrackRequired": "Por favor agrega al menos una pista",
    "release.audioRequired": "Debes subir archivos de audio para todas las pistas",
    "release.fillRequired": "Por favor completa los campos requeridos",
    "release.maxImages": "Máximo 10 imágenes",
    "release.imageDimensions": "La imagen debe ser 3000x3000 píxeles. Subida: {width}x{height}",
    "release.imageReadError": "No se pudo leer la imagen",
    "release.imageUploaded": "Imagen subida",
    "release.imageUploadError": "No se pudo subir {filename}",
    "release.imageDeleteError": "No se pudo eliminar la imagen",
    "release.trackAddError": "No se pudo agregar la pista",
    "release.trackUpdateError": "No se pudo actualizar la pista",
    "release.trackDeleteError": "No se pudo eliminar la pista",
    "release.audioUploaded": "Archivo de audio subido",
    "release.audioUploadError": "No se pudo subir el archivo de audio",
    "release.acceptTerms": "Por favor acepta los términos",
    "release.trackCoverRequired": "Se requiere pista e imagen de portada",
    "release.missingAudio": "{count} pista(s) sin archivos de audio",
    "release.submitted": "¡Lanzamiento enviado!",
    "release.submitCancelled": "Envío cancelado",
    "release.submitError": "No se pudo enviar el lanzamiento",
    "release.enterSongName": "Por favor ingresa el nombre de la canción",
    "release.trackAdded": "Pista agregada",
    "release.uploading": "Subiendo...",
    "release.coverUploading": "Imagen",
    "release.audioFileUploading": "Archivo de Audio",
    "release.back": "Atrás",
    "release.next": "Siguiente",
    "release.submitRelease": "Enviar Lanzamiento",
    "release.selectTypeTitle": "¿Qué te gustaría lanzar?",
    "release.selectTypeDesc": "Elige el tipo de lanzamiento que deseas crear",
    "release.singleSong": "Canción Individual",
    "release.singleSongDesc": "Lanza una sola pista con su propia portada. Perfecto para singles.",
    "release.epAlbum": "EP / Álbum",
    "release.epAlbumDesc": "Lanza múltiples pistas con una portada compartida. Ideal para EPs y álbumes.",
    "release.track": "pista",
    "release.tracks": "pistas",
    "release.coverImage": "portada",
    "release.albumCover": "portada del álbum",
    "release.continue": "Continuar",
    "release.orContinueDraft": "O continúa desde tus borradores",
    "release.untitled": "Sin título",
    "release.addFromDrafts": "Agregar de mis borradores",
    "release.selectReleaseType": "Por favor selecciona un tipo de lanzamiento",
    "release.singleTrackOnly": "Los lanzamientos individuales solo pueden tener 1 pista",
    "release.albumCoverLabel": "Portada del Álbum (Todas las pistas usarán esta portada)",
    "release.singleCoverLabel": "Imagen de Portada",
    "release.albumCoverInfo": "Portada del Álbum",
    "release.albumCoverInfoDesc": "Esta imagen de portada se usará para todas las pistas en tu EP/Álbum.",
    "release.uploadCover": "Subir Portada",
    "release.coverUploaded": "Imagen de portada subida",
    "release.releaseType": "Tipo de Lanzamiento",
    "release.releaseDate": "Fecha de Lanzamiento",
    "release.language": "Idioma",
    "release.mainGenre": "Género Principal",
    "release.selectGenre": "Selecciona un género",
    "release.labelName": "Nombre del Sello",
    "release.labelPlaceholder": "Nombre de tu sello discográfico",
    "release.upcCode": "Código UPC",
    "release.upcNote": "Si no tienes uno, generaremos uno para ti",
    "release.platforms": "Plataformas",
    "release.aiCoverTitle": "Generar Portada con IA",
    "release.aiCoverSubtitle": "Crea una portada única usando inteligencia artificial",
    "release.coverImportant": "Importante sobre la Portada",
    "release.coverWarning": "Las imágenes deben ser 3000x3000 píxeles en formato JPG o PNG",
    "release.coverOwnership": "Solo usa imágenes de las que tengas los derechos",
    "release.coverImages": "Imágenes de Portada",
    "release.uploadOrDrag": "Sube o arrastra archivos aquí",
    "release.imagesUploaded": "imágenes subidas",
    "release.platformInfo": "Información de la Plataforma",
    "release.platformUrlPlaceholder": "URL de tu perfil en la plataforma",
    "release.leaveEmpty": "Déjalo vacío si no tienes cuenta",
    "release.almostDone": "¡Casi Listo!",
    "release.previewDetails": "Revisa los detalles de tu lanzamiento",
    "release.releaseInfo": "Información del Lanzamiento",
    "release.releaseTypeLabel": "Tipo de Lanzamiento",
    "release.releaseDateLabel": "Fecha de Lanzamiento",
    "release.mainGenreLabel": "Género Principal",
    "release.languageLabel": "Idioma",
    "release.coverLabel": "Portada",
    "release.trackLabel": "Pistas",
    "release.imagesText": "imágenes",
    "release.songsText": "canciones",
    "release.platformsDistribute": "Plataformas de Distribución",
    "release.tracksTitle": "Pistas",
    "release.audioUploadedStatus": "Audio subido",
    "release.audioMissingStatus": "Audio faltante",
    "release.looksGood": "¡Se ve bien!",
    "release.confirmBelow": "Confirma los detalles abajo",
    "release.importantConfirms": "Confirmaciones Importantes",
    "release.confirm1": "Confirmo que tengo todos los derechos de esta música",
    "release.confirm2": "Confirmo que la información de la portada es correcta",
    "release.confirm3": "Confirmo que los metadatos de la pista son precisos",
    "release.confirm4": "Confirmo que los créditos son correctos",
    "release.confirm5": "Acepto los términos y condiciones",
    "release.warningEditing": "Lanzamiento en modo de edición",
    "release.warningEditingDesc": "Este lanzamiento necesita cambios antes de ser enviado nuevamente",
    "release.adminNote": "Nota del Administrador",
    
    // Common extras
    "common.filter": "Filtrar",
    "common.all": "Todos",
    "common.copy": "Copiar",
    "common.optional": "Opcional",
    "common.user": "Usuario",
    "common.status": "Estado",
    "common.default": "Predeterminado",
    "common.yes": "Sí",
    "common.no": "No",
    "common.other": "Otro",
    "common.noResults": "Sin resultados",
    
    // Profile
    "profile.title": "Configuración del Perfil",
    "profile.subtitle": "Administra tu cuenta y configuración",
    "profile.accountInfo": "Información de la Cuenta",
    "profile.addressInfo": "Información de Dirección",
    "profile.statistics": "Estadísticas",
    "profile.financial": "Financiero",
    "profile.firstName": "Nombre",
    "profile.lastName": "Apellido",
    "profile.email": "Correo Electrónico",
    "profile.status": "Estado",
    "profile.address": "Dirección",
    "profile.city": "Ciudad",
    "profile.country": "País",
    "profile.postalCode": "Código Postal",
    
    // Statuses
    "status.draft": "Borrador",
    "status.submitted": "Enviado",
    "status.inReview": "En Revisión",
    "status.needsEdits": "Necesita Ediciones",
    "status.approved": "Aprobado",
    "status.rejected": "Rechazado",
    "status.live": "En Vivo",
    "status.scheduled": "Programado",
    "status.takenDown": "Retirado",
    
    // Release Detail Page
    "releaseDetail.backToReleases": "Volver a Lanzamientos",
    "releaseDetail.releaseTime": "Hora de Lanzamiento",
    "releaseDetail.genre": "Género",
    "releaseDetail.releaseType": "Tipo de Lanzamiento",
    "releaseDetail.explicitContent": "Contenido Explícito",
    "releaseDetail.releaseInfo": "Información del Lanzamiento",
    "releaseDetail.version": "Versión",
    "releaseDetail.subGenre": "Subgénero",
    "releaseDetail.titleLanguage": "Idioma del Título",
    "releaseDetail.recordLabel": "Sello Discográfico",
    "releaseDetail.publisher": "Editorial",
    "releaseDetail.timeMode": "Modo de Tiempo",
    "releaseDetail.localTime": "Hora Local",
    "releaseDetail.global": "Global",
    "releaseDetail.selectedPlatforms": "Plataformas Seleccionadas",
    "releaseDetail.trackInfo": "Información de la Pista",
    "releaseDetail.noTracks": "Sin pistas",
    "releaseDetail.statusHistory": "Historial de Estado",
    "releaseDetail.untitled": "Sin título",
    "releaseDetail.englishTitle": "Título en Inglés",
    "releaseDetail.lyricsLanguage": "Idioma de las Letras",
    "releaseDetail.primaryArtists": "Artistas Principales",
    "releaseDetail.featuredArtists": "Artistas Invitados",
    "releaseDetail.songwriters": "Compositores",
    "releaseDetail.writers": "Escritores",
    "releaseDetail.composers": "Compositores",
    "releaseDetail.producers": "Productores",
    "releaseDetail.trackAudio": "Audio de la Pista",
    "releaseDetail.browserNotSupported": "Tu navegador no soporta el elemento de audio",
    "releaseDetail.lyrics": "Letras",
    
    // Admin Release
    "adminRelease.downloadPackage": "Descargar Paquete",
    "adminRelease.editNotes": "Editar Notas",
    "adminRelease.newStatus": "Nuevo Estado",
    "adminRelease.reasonRequired": "Se requiere motivo",
    "adminRelease.noteOptional": "Nota (opcional)",
    "adminRelease.reasonPlaceholder": "Ingresa el motivo del cambio de estado",
    
    // Admin Review Queue
    "adminReview.subtitle": "Revisar y aprobar lanzamientos",
    "adminReview.statusFilter": "Filtrar por estado",
    "adminReview.allStatuses": "Todos los estados",
    "adminReview.noReleases": "No hay lanzamientos",
    "adminReview.noReleasesDesc": "No hay lanzamientos para revisar",
    "adminReview.noDateSet": "Sin fecha establecida",
    
    // Admin Artists
    "adminArtists.searchPlaceholder": "Buscar artistas...",
    "adminArtists.pendingApproval": "Aprobación Pendiente",
    "adminArtists.banned": "Baneado",
    "adminArtists.plan": "Plan",
    "adminArtists.balance": "Saldo",
    "adminArtists.withdrawable": "Retirable",
    
    // Release Form - Genre & Language
    "releaseForm.primaryGenre": "Género Principal",
    "releaseForm.subGenre": "Subgénero",
    "releaseForm.subGenreOptional": "Subgénero (opcional)",
    "releaseForm.selectPrimaryGenre": "Selecciona género principal",
    "releaseForm.selectSubGenre": "Selecciona subgénero",
    "releaseForm.selectPrimaryFirst": "Selecciona primero el género principal",
    "releaseForm.searchGenre": "Buscar género",
    "releaseForm.searchSubGenre": "Buscar subgénero",
    "releaseForm.noGenreFound": "Género no encontrado",
    "releaseForm.noSubGenreFound": "Subgénero no encontrado",
    "releaseForm.trackLanguage": "Idioma de la Pista",
    "releaseForm.titleLanguage": "Idioma del Título",
    "releaseForm.selectTrackLanguage": "Selecciona idioma de la pista",
    "releaseForm.selectTitleLanguage": "Selecciona idioma del título",
    "releaseForm.searchLanguage": "Buscar idioma",
    "releaseForm.noLanguageFound": "Idioma no encontrado",
    "releaseForm.instrumentalNote": "Selecciona instrumental si la pista no tiene letra",
    "releaseForm.multipleLanguagesNote": "Si la pista tiene letras en múltiples idiomas, selecciona el principal",
    "releaseForm.selectType": "Selecciona Tipo",
    "releaseForm.track": "pista",
    "releaseForm.tracks": "pistas",
    
    // Release Form - Explicit
    "releaseForm.explicitLyrics": "Contenido Explícito",
    "releaseForm.selectExplicit": "Selecciona tipo de contenido",
    "releaseForm.explicitRequired": "Se requiere selección de contenido explícito",
    "releaseForm.explicitWarning": "Las tiendas pueden restringir contenido explícito",
    "releaseForm.explicitMarked": "Marcado como explícito",
    "releaseForm.radioEditVersion": "Versión para Radio",
    "releaseForm.explicit": "Explícito",
    "releaseForm.explicitDesc": "Contiene contenido explícito",
    "releaseForm.cleanEdited": "Limpio/Editado",
    "releaseForm.cleanEditedDesc": "Versión editada sin contenido explícito",
    "releaseForm.notExplicit": "No Explícito",
    "releaseForm.notExplicitDesc": "No contiene contenido explícito",
    "releaseForm.unknown": "Desconocido",
    "releaseForm.unknownDesc": "Contenido no especificado",
    
    // Release Form - Other
    "releaseForm.isInstrumental": "Instrumental",
    "releaseForm.instrumentalDesc": "Sin letras vocales",
    "releaseForm.featuredArtists": "Artistas Invitados",
    "releaseForm.addFeaturedArtist": "Agregar Artista Invitado",
    "releaseForm.primaryArtist": "Artista Principal",
    "releaseForm.trackTitle": "Título de la Pista",
    "releaseForm.enterTrackTitle": "Ingresa el título de la pista",
    "releaseForm.trackTitleRequired": "Se requiere título de la pista",
    "releaseForm.primaryArtistRequired": "Se requiere artista principal",
    "releaseForm.primaryGenreRequired": "Se requiere género principal",
    "releaseForm.trackLanguageRequired": "Se requiere idioma de la pista",
    
    // Single Release Wizard
    "wizard.audioFile": "Archivo de Audio",
    "wizard.readyForDistribution": "Listo para distribución",
    "wizard.uploading": "Subiendo",
    "wizard.pleaseWait": "Por favor espera",
    "wizard.uploadAudioFile": "Subir archivo de audio",
    "wizard.audioFormatInfo": "WAV o FLAC, mínimo 16-bit/44.1kHz",
    "wizard.trackDetails": "Detalles de la Pista",
    "wizard.trackTitle": "Título de la Pista",
    "wizard.enterTrackTitle": "Ingresa el título",
    "wizard.primaryArtist": "Artista Principal",
    "wizard.artistName": "Nombre del Artista",
    "wizard.coverArt": "Arte de Portada",
    "wizard.coverRequirements": "Requisitos de la Portada",
    "wizard.squareFormat": "Formato cuadrado",
    "wizard.minResolution": "Mínimo 3000x3000 px",
    "wizard.formatJpgPng": "JPG o PNG",
    "wizard.noUrlsAllowed": "No se permiten URLs en la imagen",
    "wizard.noBluryImages": "No se permiten imágenes borrosas o pixeladas",
    "wizard.uploadCover": "Subir Portada",
    "wizard.coverUploaded": "Portada subida",
    "wizard.distributionType": "Tipo de Distribución",
    "wizard.wasThisReleased": "¿Fue lanzado anteriormente?",
    "wizard.newRelease": "Nuevo Lanzamiento",
    "wizard.newReleaseDesc": "Nunca fue lanzado antes",
    "wizard.transferRelease": "Transferir Lanzamiento",
    "wizard.transferReleaseDesc": "Fue lanzado en otro distribuidor",
    "wizard.upcCode": "Código UPC",
    "wizard.isrcCode": "Código ISRC",
    "wizard.originalReleaseDate": "Fecha de Lanzamiento Original",
    
    // Explicit options
    "explicit.explicit": "Explícito",
    "explicit.explicitDesc": "Contiene contenido explícito o para adultos como lenguaje fuerte, violencia o temas sexuales.",
    "explicit.clean": "Limpio / Editado",
    "explicit.cleanDesc": "Una versión apta para radio con contenido explícito eliminado o editado. Requiere que exista una versión explícita.",
    "explicit.notExplicit": "No Explícito",
    "explicit.notExplicitDesc": "No contiene ningún contenido explícito. Apto para toda la familia.",
    "explicit.unknown": "Desconocido",
    "explicit.unknownDesc": "La clasificación del contenido no está determinada o no es aplicable.",
    
    "wizard.credits": "Créditos",
    "wizard.songwriters": "Compositores de Letras",
    "wizard.add": "Agregar",
    "wizard.songwriterName": "Nombre del Compositor",
    "wizard.songwriterPlaceholder": "Nombre completo del compositor",
    "wizard.lyricists": "Letristas",
    "wizard.lyricistName": "Nombre del Letrista",
    "wizard.contributors": "Colaboradores",
    "wizard.contributorPlaceholder": "Nombre del colaborador",
    "wizard.producerPlaceholder": "Nombre del productor",
    "wizard.name": "Nombre",
    "wizard.selectRole": "Selecciona rol",
    "wizard.productionTeam": "Equipo de Producción",
    "wizard.recordLabel": "Sello Discográfico",
    "wizard.recordLabelOptional": "Sello discográfico (opcional)",
    "wizard.versionPlaceholder": "ej. Remix, Acoustic, Live",
    "wizard.isrcPlaceholder": "ISRC (si lo tienes)",
    "wizard.minResolutionRecommended": "Min 1400x1400 px (3000x3000 recomendado)",
    "wizard.upcPlaceholder": "Ingresa código UPC de 12 dígitos",
    "wizard.licensedContent": "Contenido con Licencia",
    "wizard.licensedContentQuestion": "¿Esta pista contiene contenido con licencia?",
    "wizard.noOriginal": "No, es contenido original",
    "wizard.yesLicensed": "Sí, contiene contenido con licencia",
    "wizard.licenseRequired": "Se requiere documento de licencia",
    "wizard.licenseRequiredDesc": "Sube la documentación de tu licencia",
    "wizard.uploadLicense": "Subir Licencia",
    "wizard.pdfOnly": "Solo PDF",
    "wizard.trackSettings": "Configuración de seguimiento",
    
    // Credit roles
    "creditRoles.composer": "Compositor",
    "creditRoles.lyricist": "Letrista",
    "creditRoles.composerLyricist": "Compositor y Letrista",
    "creditRoles.arranger": "Arreglista",
    "creditRoles.mixer": "Mezclador",
    "creditRoles.mastering": "Masterización",
    "creditRoles.recording": "Grabación",
    "creditRoles.instrumentalist": "Instrumentista",
    "creditRoles.vocalist": "Vocalista",
    "creditRoles.other": "Otro",
    "creditRoles.producer": "Productor",
    "creditRoles.executiveProducer": "Productor Ejecutivo",
    "creditRoles.coProducer": "Co-Productor",
    "creditRoles.engineer": "Ingeniero",
    "creditRoles.assistant": "Asistente",
    
    // Release form
    "releaseForm.instrumental": "Instrumental (Sin Letra)",
    "releaseForm.multipleLanguages": "Múltiples Idiomas",
    
    // Track specific
    "wizard.track.lyricsLanguage": "Idioma de la Pista (Language of Lyrics)",
    "wizard.track.lyricsLanguageDesc": "Idioma de las letras o vocales",
    "wizard.track.explicitLyrics": "Letras Explícitas / Aviso Parental",
    "wizard.track.selectContentType": "Selecciona tipo de contenido",
    "wizard.track.addFeaturedArtist": "Agregar artista invitado",
    "wizard.track.useExistingIsrc": "Usar código ISRC existente",
    
    "wizard.licenseDocument": "Documento de Licencia",
    "wizard.uploaded": "Subido",
    "wizard.licenseUploaded": "Licencia subida",
    "wizard.licenseUploadFailed": "Error al subir la licencia",
    
    // Wizard Section Tabs
    "wizard.sections.trackInfo": "Información de la Pista",
    "wizard.sections.releaseSettings": "Configuración del Lanzamiento",
    "wizard.sections.moreOptions": "Más Opciones",
    "wizard.sections.review": "Revisar",
    
    // Wizard Page Header
    "wizard.newSingleRelease": "Nuevo Single",
    "wizard.newSingleReleaseDesc": "Lanza una sola pista",
    "wizard.selectReleaseType": "Selecciona tipo de lanzamiento",
    "wizard.singleTrack": "Pista Individual",
    "wizard.singleTrackDesc": "Lanza una sola canción",
    "wizard.epAlbum": "EP / Álbum",
    "wizard.epAlbumDesc": "Lanza múltiples pistas",
    "wizard.loadFromDrafts": "Cargar desde Borradores",
    "wizard.goBack": "Volver",
    
    // Wizard Toast Messages
    "wizard.audioUploaded": "Audio subido exitosamente",
    "wizard.audioUploadFailed": "Error al subir el audio",
    "wizard.coverMustBeSquare": "La portada debe ser cuadrada",
    "wizard.coverMinResolution": "Resolución mínima 3000x3000",
    "wizard.coverReadFailed": "Error al leer la portada",
    "wizard.coverUploaded": "Portada subida",
    "wizard.coverUploadFailed": "Error al subir la portada",
    "wizard.releaseLoadFailed": "Error al cargar el lanzamiento",
    "wizard.draftsLoadFailed": "Error al cargar los borradores",
    "wizard.fixSectionErrors": "Por favor corrige los errores antes de continuar",
    "wizard.draftSaved": "Borrador guardado",
    "wizard.draftSaveFailed": "Error al guardar el borrador",
    "wizard.releaseSubmitted": "¡Lanzamiento enviado!",
    "wizard.releaseSubmitFailed": "Error al enviar el lanzamiento",
    "wizard.drafts": "Borradores",
    "wizard.noDrafts": "Sin borradores",
    "wizard.untitledRelease": "Lanzamiento sin título",
    "wizard.deleteDraft": "Eliminar Borrador",
    
    // Validation messages
    "validation.minContributors": "Debes agregar al menos un colaborador.",
    "validation.minProductionTeam": "Debes agregar al menos un miembro del equipo de producción.",

    // Spotify
    "spotify.title": "Spotify for Artists",
    "spotify.comingSoon": "Próximamente",
    "spotify.description": "Accede a tu cuenta de Spotify Artist directamente desde el panel de EAM.",
    
    // Admin
    "admin.dashboard": "Panel de Administración",
    "admin.reviewQueue": "Cola de Revisión",
    "admin.artists": "Artistas",
    "admin.announcements": "Anuncios",
    "admin.pendingUsers": "Usuarios Pendientes",
    "admin.pendingReleases": "Lanzamientos Pendientes",
    "admin.payoutRequests": "Solicitudes de Pago",
    "admin.deleteUser": "Eliminar Usuario",
    "admin.deleteUserConfirm": "¿Estás seguro de eliminar este usuario?",
    "admin.yesDelete": "Sí, Eliminar",
    "admin.close": "Cerrar",
    "admin.deleteTicket": "Eliminar Ticket",
    "admin.deleteTicketConfirm": "¿Estás seguro de eliminar este ticket?",
    "admin.deleteRelease": "Eliminar Lanzamiento",
    "admin.deleteReleaseConfirm": "¿Estás seguro de eliminar este lanzamiento?",
    "admin.deleteFailed": "Error al eliminar",
    
    // Notifications
    "notifications.title": "Notificaciones",
    "notifications.markAllRead": "Marcar todo como leído",
    "notifications.none": "Sin notificaciones",
    "notifications.empty": "Aún no hay notificaciones",
    
    // Common
    "common.yes": "Sí",
    "common.no": "No",
    "common.cancel": "Cancelar",
    "common.add": "Añadir",
    "common.update": "Actualizar",
    "common.delete": "Eliminar",
    "common.save": "Guardar",
    "common.current": "Actual",
    "common.optional": "Opcional",
    "common.untitled": "Sin título",
    "common.unknownArtist": "Artista desconocido",
    "common.operationFailed": "Operación fallida",
    
    // Wizard - Lyrics
    "wizard.lyrics.label": "Letra (opcional)",
    "wizard.lyrics.placeholder": "Introduce la letra aquí...",
    "wizard.lyrics.description": "Las letras se pueden mostrar en DSP (Apple Music, Spotify, etc.)",
    
    // Wizard - Publishing
    "wizard.publishing.percentPlaceholder": "Introduzca el porcentaje (1-99)",
    "wizard.publishing.hasPublisher": "¿Tienes una editorial?",
    "wizard.publishing.publisherName": "Nombre del editor",
    "wizard.publishing.publisherPlaceholder": "Introduzca el nombre del editor",
    "wizard.publishing.registeredPro": "¿Está registrado en un PRO/CMO?",
    
    // Wizard - Uploaded files
    "wizard.uploadedCover": "portada cargada",
    "wizard.uploadedFile": "archivo subido",
    
    // Payout Methods
    "payoutMethods.otpSent": "Código de verificación enviado a su correo electrónico",
    "payoutMethods.otpRequired": "Ingresa el código de verificación de 6 dígitos",
    "payoutMethods.methodUpdated": "Tu método de pago ha sido actualizado.",
    "payoutMethods.verificationFailed": "La verificación falló",
    "payoutMethods.editMethod": "Editar método de pago",
    "payoutMethods.addMethod": "Agregar método de pago",
    "payoutMethods.editDesc": "Actualice su método de pago existente",
    "payoutMethods.addDesc": "Añade un método de pago para retirar tus ganancias",
    "payoutMethods.bank": "banco",
    "payoutMethods.accountHolder": "Nombre del titular de la cuenta",
    "payoutMethods.fullName": "Nombre completo",
    "payoutMethods.bankName": "Nombre del banco",
    "payoutMethods.country": "País",
    "payoutMethods.countryPlaceholder": "Estados Unidos",
    "payoutMethods.paypalEmail": "Dirección de correo electrónico de PayPal",
    "payoutMethods.title": "Métodos de pago",
    "payoutMethods.subtitle": "Añade tu método de pago para retirar tus ganancias",
    "payoutMethods.addNew": "Agregar nuevo",
    "payoutMethods.securityNotice": "Aviso de seguridad",
    "payoutMethods.securityDesc": "Todos los cambios en sus métodos de pago requieren verificación por correo electrónico. Esto es para proteger su cuenta del acceso no autorizado.",
    "payoutMethods.noMethods": "No se encontró ningún método de pago",
    "payoutMethods.noMethodsDesc": "Debes agregar un método de pago para poder retirar tus ganancias.",
    "payoutMethods.bankTransfer": "Transferencia bancaria",
    "payoutMethods.default": "Por defecto",
    "payoutMethods.verified": "Verificado",
    "payoutMethods.emailVerification": "Verificación de correo electrónico",
    "payoutMethods.enterOtp": "Ingresa el código de 6 dígitos enviado a tu correo electrónico",
    "payoutMethods.verificationCode": "Código de verificación",
    "payoutMethods.codeExpires": "El código caducará en {time}",
    "payoutMethods.codeExpired": "El código ha caducado. Por favor solicite uno nuevo.",
    "payoutMethods.resendIn": "Reenviar",
    "payoutMethods.resendCode": "Reenviar código",
    "payoutMethods.verify": "verificar",
    "payoutMethods.deleteMethod": "Eliminar método de pago",
    "payoutMethods.deleteConfirm": "¿Estás seguro de que deseas eliminar este método de pago? Esta acción no se puede deshacer.",
    
    // Login
    "login.heroTitle": "Distribuye tu música",
    "login.heroHighlight": "globalmente",
    "login.heroSubtitle": "Llega a millones de oyentes en todo el mundo",
    "auth.forgotPassword": "¿Olvidaste tu contraseña?",
    "auth.resetPassword": "Restablecer Contraseña",
    "auth.resetPasswordDesc": "Ingresa tu email para recibir un enlace de restablecimiento",
    "auth.sendResetLink": "Enviar enlace de restablecimiento",
    "auth.backToLogin": "Volver a iniciar sesión",
    "auth.resetLinkSent": "Enlace de restablecimiento enviado",
    "auth.turnstileRequired": "Por favor completa la verificación",
    
    // Artist Autocomplete
    "artist.saved": "Artista guardado",
    "artist.noResults": "Sin resultados",
    "artist.saveArtist": "Guardar artista",
    "artist.addArtist": "Agregar artista",
    "artist.addPlaceholder": "Nombre del artista",
    "artist.addPrimaryArtist": "Agregar Artista Principal",
    "artist.addFeaturedArtist": "Agregar Artista Invitado",
    "artist.artistName": "Nombre del Artista",
    "artist.enterOrSearch": "Ingresa o busca artistas",
    "artist.noMatching": "Sin artistas coincidentes",
    "artist.addAsArtist": "Agregar como artista",
    "artist.enterMinChars": "Ingresa al menos 2 caracteres",
    "artist.searchSpotify": "Buscar",
    "artist.manualLink": "Pegar enlace",
    "artist.spotifyProfileLink": "Enlace del artista de Spotify",
    "artist.spotifyLinkHelp": "Pegue la URL del perfil de artista de Spotify o la ID del artista",
    "artist.linkSpotify": "Vincular perfil de Spotify",
    "artist.addWithoutSpotify": "Añadir sin enlace de Spotify",
    "artist.tryManualLink": "Pruebe la pestaña 'Pegar enlace' para ingresar la URL de Spotify",
    "artist.invalidSpotifyLink": "Enlace o ID de Spotify no válido",
    "artist.nameRequired": "El nombre del artista es obligatorio.",
    "artist.spotifyLinked": "Perfil de Spotify vinculado correctamente",
    "artist.spotifyIdSaved": "ID de Spotify guardado",
    
    // Releases Page
    "releases.allReleases": "Todos los Lanzamientos",
    "releases.drafts": "Borradores",
    "releases.tableTitle": "Título",
    "releases.tableArtist": "Artista",
    "releases.tableTracks": "Pistas",
    "releases.tableLastUpdate": "Última Actualización",
    "releases.tableProgress": "Progreso",
    "releases.tableActions": "Acciones",
    "releases.releaseDate": "Fecha de Lanzamiento",
    "releases.deleteDraftTitle": "Eliminar Borrador",
    "releases.deleteReleaseTitle": "Eliminar Lanzamiento",
    "releases.deleteFailed": "Error al eliminar",
    "releases.untitled": "Lanzamiento Sin Título",
    "releases.needsEdits": "Necesita Ediciones",
    "releases.yesRemoveBtn": "Sí, Eliminar",
    "releases.deleteBtn": "Eliminar",
    
    // Credit Roles (Canonical IDs)
    "role.COMPOSER": "Compositor",
    "role.LYRICIST": "Letrista",
    "role.COMPOSER_LYRICIST": "Compositor y Letrista",
    "role.PRODUCER": "Productor",
    "role.EXECUTIVE_PRODUCER": "Productor Ejecutivo",
    "role.CO_PRODUCER": "Co-Productor",
    "role.ASSOCIATE_PRODUCER": "Productor Asociado",
    "role.MIXING_ENGINEER": "Ingeniero de Mezcla",
    "role.MASTERING_ENGINEER": "Ingeniero de Masterización",
    "role.RECORDING_ENGINEER": "Ingeniero de Grabación",
    "role.ASSISTANT_ENGINEER": "Ingeniero Asistente",
    "role.ARRANGER": "Arreglista",
    "role.REMIXER": "Remixer",
    "role.ORCHESTRA": "Orquesta",
    "role.CHOIR": "Coro",
    
    // Tax Status
    "tax.required": "Se requiere información fiscal",
    "tax.requiredDesc": "Completa tu información fiscal para recibir pagos",
    "tax.statusNone": "Sin información fiscal",
    "tax.statusPersonal": "Impuesto personal",
    "tax.statusCompany": "Impuesto empresarial",
    "tax.cannotPayout": "No se pueden realizar pagos sin información fiscal",
    
    // Validation Messages
    "validation.audioRequired": "El archivo de audio es obligatorio",
    "validation.audioFormatWav": "El archivo de audio debe estar en formato WAV o FLAC",
    "validation.sampleRate": "La tasa de muestreo debe ser al menos 44.1kHz",
    "validation.bitDepth": "La profundidad de bits debe ser al menos 16-bit",
    "validation.titleRequired": "El título de la pista es obligatorio",
    "validation.titleLanguageRequired": "El idioma del título es obligatorio",
    "validation.primaryArtistRequired": "Se requiere al menos un artista principal",
    "validation.primaryGenreRequired": "La selección del género principal es obligatoria",
    "validation.explicitRequired": "La selección del tipo de contenido es obligatoria",
    "validation.explicitWarning": "Las tiendas pueden restringir contenido explícito",
    "validation.coverRequired": "La imagen de portada es obligatoria",
    "validation.distributionTypeRequired": "Se requiere tipo de distribución",
    "validation.upcRequired": "Se requiere código UPC para transferencias",
    "validation.isrcRequired": "Se requiere código ISRC para transferencias",
    "validation.originalDateRequired": "Se requiere fecha original para transferencias",
    "validation.songwriterRequired": "Se requiere al menos un compositor",
    "validation.songwriterNameFormat": "El nombre debe estar en formato Nombre Apellido",
    "validation.songwriterRoleRequired": "Se requiere rol",
    "validation.licensedContentRequired": "Indica si hay contenido con licencia",
    "validation.licenseFileRequired": "Se requiere documento de licencia",
    "validation.contributorRequired": "Se requiere al menos un colaborador",
    "validation.contributorNameFormat": "El nombre del colaborador debe estar en formato Nombre Apellido",
    "validation.productionTeamRequired": "Se requiere al menos un miembro del equipo de producción",
    "validation.productionTeamNameFormat": "El nombre debe estar en formato Nombre Apellido",
    "validation.platformRequired": "Se requiere selección de al menos una plataforma",
    "validation.timeSyncRequired": "Se requiere modo de sincronización de tiempo",
    "validation.releaseDateRequired": "La fecha de lanzamiento es obligatoria",
    "validation.releaseDateMinDays": "La fecha de lanzamiento debe ser al menos 7 días en el futuro",
    "validation.trackCountRequired": "Se requieren al menos 2 pistas para EP/Álbum",
    "validation.trackLanguageRequired": "Se requiere idioma de la pista",
    "validation.trackHasErrors": "La pista tiene errores",
    "validation.fixSectionErrors": "Por favor corrige los errores en la sección",
    "validation.weeklyLimitReached": "Límite semanal alcanzado",
    "validation.firstArtistMustMatch": "El primer artista debe coincidir",
    "validation.artistMustMatchAlbum": "El artista debe coincidir con el álbum",
    "validation.isrcRequiredTransfer": "Se requiere ISRC para transferencias",
    "validation.publishingRequired": "Se requiere información de publicación",
    "validation.publisherStatusRequired": "Se requiere estado del editor",
    "validation.publisherNameRequired": "Se requiere nombre del editor",
    "validation.proStatusRequired": "Se requiere estado de PRO",
    "validation.proSelectionRequired": "Se requiere selección de PRO",
    "validation.ipiRequired": "Se requiere número IPI",
    "validation.validPercentage": "Ingresa un porcentaje válido",
    "validation.ownershipRequired": "Se requiere información de propiedad",
    "validation.termsRequired": "Debes aceptar los términos",
    "releases.track": "Pista",
    
    // Toast Messages
    "toast.saveSuccess": "Guardado exitosamente",
    "toast.saveFailed": "Error al guardar",
    "toast.deleteSuccess": "Eliminado exitosamente",
    "toast.deleteFailed": "Error al eliminar",
    "toast.uploadSuccess": "Subido exitosamente",
    "toast.uploadFailed": "Error al subir",
    "toast.submitSuccess": "Enviado exitosamente",
    "toast.submitFailed": "Error al enviar",
    "toast.loginSuccess": "Inicio de sesión exitoso",
    "toast.loginFailed": "Error de inicio de sesión",
    "toast.logoutSuccess": "Sesión cerrada",
    "toast.copySuccess": "Copiado al portapapeles",
    "toast.errorOccurred": "Ocurrió un error",
    "toast.pleaseFixErrors": "Por favor corrige los errores",
    "toast.releaseSubmitted": "Lanzamiento enviado",
    "toast.draftSaved": "Borrador guardado",
    "toast.coverUploaded": "Portada subida",
    "toast.audioUploaded": "Audio subido",
    "toast.invalidCredentials": "Credenciales inválidas",
    "toast.sessionExpired": "Sesión expirada",

    // === Auto-generated i18n keys ===
    "aiAdvisor.aiName": "IA",
    "aiAdvisor.title": "Asesor Musical IA",
    "aiAdvisor.subtitle": "Obtén estrategias y análisis de IA para tu carrera.",
    "aiAdvisor.thinking": "La IA está pensando...",
    "aiAdvisor.stats.totalReleases": "Lanzamientos totales",
    "aiAdvisor.stats.totalTracks": "Pistas totales",
    "aiAdvisor.stats.chatHistory": "Historial de chat",
    "aiAdvisor.stats.messages": "Mensajes",
    "aiAdvisor.support.email": "Tu correo electrónico",
    "aiAdvisor.support.problem": "Tu problema (brevemente)",
    "aiAdvisor.clear": "Borrar",
    "aiAdvisor.clearChat": "Borrar chat",
    "aiAdvisor.connectAgent": "Conéctese con un representante del cliente",
    "aiAdvisor.contextDesc": "La IA tiene en cuenta los datos de su cuenta actual para brindarle asesoramiento personalizado.",
    "aiAdvisor.contextTitle": "Contexto del asesor",
    "aiAdvisor.errors.cannotRespond": "Lo siento, no puedo responder en este momento. Inténtelo de nuevo más tarde.",
    "aiAdvisor.errors.fillFields": "Por favor complete todos los campos.",
    "aiAdvisor.errors.generic": "Se produjo un error, inténtalo de nuevo.",
    "aiAdvisor.errors.noChatToExport": "No se encontró ningún chat para exportar.",
    "aiAdvisor.errors.ticketFailed": "Error al crear la solicitud de soporte.",
    "aiAdvisor.export": "Exportar",
    "aiAdvisor.inputPlaceholder": "Hazle a la IA una pregunta sobre tu carrera musical...",
    "aiAdvisor.prompts.audienceAnalysis": "Análisis de audiencia",
    "aiAdvisor.prompts.brandingAdvice": "Consejos de marca",
    "aiAdvisor.prompts.growthTips": "Dar consejos de crecimiento",
    "aiAdvisor.prompts.livePerformance": "Estrategia de actuación en vivo",
    "aiAdvisor.prompts.playlistPitching": "Estrategia de presentación de listas de reproducción",
    "aiAdvisor.prompts.releaseStrategy": "¿Cuál debería ser mi estrategia de lanzamiento?",
    "aiAdvisor.prompts.revenueOptimization": "Optimización de ingresos",
    "aiAdvisor.prompts.socialMediaPlan": "Crea un plan de redes sociales",
    "aiAdvisor.stats.accountStatus": "Estado de la cuenta",
    "aiAdvisor.stats.active": "Activo",
    "aiAdvisor.success.chatCleared": "Chat borrado.",
    "aiAdvisor.success.chatExported": "Chat exportado.",
    "aiAdvisor.success.ticketCreated": "Solicitud de soporte creada. Nos comunicaremos con usted pronto.",
    "aiAdvisor.support.cancel": "Cancelar",
    "aiAdvisor.support.desc": "Nuestros representantes de atención al cliente se comunicarán con usted lo antes posible.",
    "aiAdvisor.support.send": "enviar",
    "aiAdvisor.support.title": "Crear solicitud de soporte",
    "aiAdvisor.supportSubject": "Asesor de IA: solicitud de soporte",
    "aiAdvisor.tipDesc": "Proporcione detalles específicos a la IA para obtener resultados más precisos.",
    "aiAdvisor.tipTitle": "consejo",
    "aiAdvisor.welcomeDesc": "Puede hacer preguntas sobre la industria de la música, estrategias de lanzamiento, marketing y aumento de ingresos.",
    "aiAdvisor.welcomeTitle": "¿Le puedo ayudar en algo?",
    "aiAdvisor.you": "tu",
    "aiMatcher.aiStrategyTips": "Sugerencias de estrategia de IA",
    "aiMatcher.analysisComplete": "Análisis de IA completado",
    "aiMatcher.analysisResults": "Resultados del análisis",
    "aiMatcher.analyzingDesc": "Las características de tu pista se comparan con miles de listas de reproducción.",
    "aiMatcher.analyzingDna": "Analizando el ADN musical...",
    "aiMatcher.description": "Descubre el potencial de tu música con nuestros algoritmos avanzados.",
    "aiMatcher.errorAnalysis": "Se produjo un error durante el análisis.",
    "aiMatcher.errorLoading": "Se produjo un error al cargar datos.",
    "aiMatcher.errorSelectRelease": "Por favor seleccione una versión",
    "aiMatcher.genreAnalysis": "Análisis de género",
    "aiMatcher.highPotential": "Alto potencial",
    "aiMatcher.newAnalysis": "Nuevo análisis",
    "aiMatcher.noPastAnalyses": "Aún no hay análisis pasados.",
    "aiMatcher.noReleases": "No se encontró música aprobada o publicada para analizar.",
    "aiMatcher.overallScore": "Puntuación de compatibilidad general",
    "aiMatcher.pastAnalyses": "Análisis pasados",
    "aiMatcher.perfectMatch": "Combinación perfecta",
    "aiMatcher.selectRelease": "Seleccione la versión para analizar",
    "aiMatcher.single": "soltero",
    "aiMatcher.startAnalysis": "Iniciar análisis",
    "aiMatcher.suggestedTiming": "Tiempo de lanzamiento sugerido",
    "aiMatcher.targetPlaylists": "Listas de reproducción objetivo",
    "aiMatcher.unknown": "Desconocido",
    "aiStudio.analyze": "analizar",
    "aiStudio.audioRepairDesc": "Reparar recortes y distorsiones.",
    "aiStudio.audioRepairName": "Reparación de audio con IA",
    "aiStudio.clarity": "claridad",
    "aiStudio.clean": "limpio",
    "aiStudio.copyrightDesc": "Escanee en busca de posibles problemas de derechos de autor",
    "aiStudio.copyrightName": "Escáner de derechos de autor con IA",
    "aiStudio.coverGenDesc": "Generar portada de álbum a partir de texto",
    "aiStudio.coverGenName": "Generador de portadas de IA",
    "aiStudio.desc": "Centro de herramientas musicales profesionales impulsado por IA.",
    "aiStudio.description": "Descripción",
    "aiStudio.distReadyDesc": "Consultar normas de distribución.",
    "aiStudio.distReadyName": "Preparación para la distribución de IA",
    "aiStudio.download": "Descargar",
    "aiStudio.downloading": "Descargando archivo...",
    "aiStudio.dragDropClick": "Arrastra y suelta o haz clic para seleccionar",
    "aiStudio.dynamic": "Dinámico",
    "aiStudio.failed": "Fallido",
    "aiStudio.frequency": "Frecuencia",
    "aiStudio.genreDetDesc": "Detección de género a partir de un archivo de audio",
    "aiStudio.genreDetName": "Detección de género de IA",
    "aiStudio.history": "Historia",
    "aiStudio.intensity": "intensidad",
    "aiStudio.issue": "Problema",
    "aiStudio.loudnessOptDesc": "Optimizar para alcanzar el valor LUFS objetivo",
    "aiStudio.loudnessOptName": "Optimización del volumen de la IA",
    "aiStudio.lyricVideoDesc": "Video con letra cronometrada",
    "aiStudio.lyricVideoName": "Vídeo con letra de IA",
    "aiStudio.lyrics": "Lírica",
    "aiStudio.lyricsPlaceholder": "Pega la letra aquí...",
    "aiStudio.metadataGenDesc": "Generar título, descripción y etiquetas.",
    "aiStudio.metadataGenName": "Generador de metadatos de IA",
    "aiStudio.modules": "Módulos",
    "aiStudio.moodDetDesc": "Análisis de energía y emociones.",
    "aiStudio.moodDetName": "Detección de estado de ánimo por IA",
    "aiStudio.musicVideoDesc": "Generar video audio-reactivo",
    "aiStudio.musicVideoName": "Vídeo musical de IA",
    "aiStudio.needAudioFile": "Primero cargue un archivo de audio.",
    "aiStudio.needPrompt": "Por favor ingrese un mensaje",
    "aiStudio.noFileToDownload": "No hay archivos para descargar",
    "aiStudio.noFileToPlay": "No hay archivos para reproducir",
    "aiStudio.noHistory": "Aún no has realizado ningún procesamiento.",
    "aiStudio.noiseRemovalDesc": "Limpiar el ruido de fondo",
    "aiStudio.noiseRemovalName": "Eliminación de ruido de IA",
    "aiStudio.passed": "Aprobado",
    "aiStudio.processError": "Se produjo un error durante el proceso.",
    "aiStudio.processHistory": "Historia del proceso",
    "aiStudio.processSuccess": "¡Proceso completado exitosamente!",
    "aiStudio.processing": "Tratamiento...",
    "aiStudio.promptPlaceholder": "Por ejemplo: un coche de ondas sintéticas iluminado con luces de neón...",
    "aiStudio.qualityScoreDesc": "Puntuación de calidad de audio de 0 a 100",
    "aiStudio.qualityScoreName": "Puntuación de calidad de audio de IA",
    "aiStudio.resultsReady": "Resultados listos",
    "aiStudio.startProcess": "Iniciar proceso",
    "aiStudio.stemSepDesc": "Voces, batería y bajo separados.",
    "aiStudio.stemSepName": "Separación de tallos por IA",
    "aiStudio.suggestedTitle": "Título sugerido",
    "aiStudio.tags": "Etiquetas",
    "aiStudio.title": "Estudio de IA",
    "aiStudio.uploadAudioFile": "Cargar archivo de audio",
    "aiStudio.view": "Ver",
    "aiStudio.visualPrompt": "Mensaje visual",
    "aiStudio.vocalEnhDesc": "Mejora la claridad y el brillo vocal.",
    "aiStudio.vocalEnhName": "Mejora vocal de IA",
    "aiVideo.addedToList": "¡Excelente! Estas agregado a la lista",
    "aiVideo.beFirst": "Sé uno de los primeros en probar",
    "aiVideo.desc": "¡Próximamente vídeos musicales con tecnología de IA!",
    "aiVideo.emailPlaceholder": "Tu dirección de correo electrónico...",
    "aiVideo.enterEmail": "Por favor ingrese una dirección de correo electrónico",
    "aiVideo.hdDesc": "Resolución 1080p y 4K para lanzamientos profesionales",
    "aiVideo.hdTitle": "Calidad HD",
    "aiVideo.joinWaitlist": "Únase a la lista de espera para acceso temprano.",
    "aiVideo.notifyMe": "Notificarme",
    "aiVideo.premiumFeature": "Característica prémium",
    "aiVideo.styleDesc": "Más de 8 estilos visuales que incluyen cinemático, anime y abstracto.",
    "aiVideo.styleTitle": "Selección de estilo",
    "aiVideo.syncDesc": "Sincronización totalmente automática al ritmo de la música.",
    "aiVideo.syncTitle": "Sincronización automática",
    "aiVideo.textToVideoDesc": "Crea la escena de tus sueños escribiendo un mensaje",
    "aiVideo.textToVideoTitle": "Texto a vídeo",
    "aiVideo.title": "Generador de vídeo IA",
    "aiVideo.waitlistSuccess": "¡Has sido agregado a la lista de espera!",
    "aiVideo.willNotify": "Le notificaremos cuando se lance la función.",
    "analytics.audienceDemographics": "Demografía de la audiencia",
    "analytics.azerbaijan": "Azerbaiyán",
    "analytics.estimatedRevenue": "Ingresos estimados",
    "analytics.female": "Mujer",
    "analytics.geographicDistribution": "Distribución geográfica",
    "analytics.germany": "Alemania",
    "analytics.male": "masculino",
    "analytics.noData": "Aún no hay datos",
    "analytics.noTrackData": "Aún no hay datos de seguimiento",
    "analytics.other": "Otro",
    "analytics.otherCountries": "Otro",
    "analytics.popularTrack": "Pista Popular",
    "analytics.popularityScore": "Puntuación de popularidad",
    "analytics.refresh": "Actualizar",
    "analytics.refreshData": "Actualizar datos",
    "analytics.revenueForecast": "Previsión de ingresos (6 meses)",
    "analytics.streamsTrend": "Tendencia de transmisiones",
    "analytics.totalStreamsStat": "Flujos totales",
    "analytics.turkey": "Turquía",
    "analytics.usa": "Estados Unidos",
    "artistConnections.apiIntegration": "Integración API",
    "artistConnections.betaTesting": "Pruebas beta",
    "artistConnections.centralManagement": "Gestión Central",
    "artistConnections.centralManagementDesc": "Gestiona todos tus perfiles de artista en plataformas desde un único panel.",
    "artistConnections.comingSoon": "Próximamente",
    "artistConnections.description": "Conecte, administre y sincronice sus perfiles de artista en plataformas de música.",
    "artistConnections.developmentProgress": "Progreso del desarrollo",
    "artistConnections.instantSync": "Sincronización instantánea",
    "artistConnections.instantSyncDesc": "Las actualizaciones de perfil se reflejan automáticamente en todas las plataformas conectadas.",
    "artistConnections.notifyMe": "Notificarme cuando esté listo",
    "artistConnections.release": "Lanzamiento",
    "artistConnections.secureConnection": "Conexión segura",
    "artistConnections.secureConnectionDesc": "Verificación segura de la plataforma y acceso a los datos con OAuth 2.0.",
    "artistConnections.supportedPlatforms": "Plataformas compatibles",
    "artistConnections.title": "Conexiones de artistas",
    "artistConnections.uiDesign": "Diseño de interfaz de usuario",
    "artistConnections.unifiedAnalytics": "Análisis unificado",
    "artistConnections.unifiedAnalyticsDesc": "Vea datos de todas las plataformas en un único panel.",
    "bioLink.addNewLink": "Agregar nuevo enlace",
    "bioLink.artistName": "Nombre del artista",
    "bioLink.avatarUpdated": "¡Foto de perfil actualizada!",
    "bioLink.bgUploaded": "Fondo subido",
    "bioLink.bioLabel": "Biografía",
    "bioLink.change": "Cambiar",
    "bioLink.copy": "Copiar",
    "bioLink.ctr": "Tasa de clics (CTR)",
    "bioLink.customBgImage": "Imagen de fondo personalizada",
    "bioLink.defaultBio": "Música y más...",
    "bioLink.defaultLink1": "Escucha mi nuevo single",
    "bioLink.defaultLink2": "Mi sitio web oficial",
    "bioLink.description": "Gestiona toda tu presencia digital con un solo enlace",
    "bioLink.errorFileSize": "El tamaño del archivo debe ser inferior a 5 MB.",
    "bioLink.errorSelectImage": "Por favor seleccione un archivo de imagen",
    "bioLink.latestReleases": "Últimos lanzamientos",
    "bioLink.linkCopied": "Enlace copiado!",
    "bioLink.linkTitlePlaceholder": "Título del enlace",
    "bioLink.newLink": "Nuevo enlace",
    "bioLink.presetThemes": "Temas preestablecidos",
    "bioLink.profileNameLabel": "Nombre del perfil",
    "bioLink.qrCode": "Código QR",
    "bioLink.save": "Guardar",
    "bioLink.saveError": "Ocurrió un error al guardar",
    "bioLink.saveSuccess": "¡El enlace de tu biografía se ha guardado correctamente!",
    "bioLink.saving": "Guardando...",
    "bioLink.socialsDesc": "Agregue sus cuentas de redes sociales para que aparezcan en su perfil.",
    "bioLink.tabLinks": "Campo de golf",
    "bioLink.tabProfile": "Perfil",
    "bioLink.tabSocials": "Redes Sociales",
    "bioLink.tabTheme": "Tema",
    "bioLink.title": "Enlace biológico inteligente",
    "bioLink.totalClicks": "Clics totales",
    "bioLink.totalViews": "Vistas totales",
    "bioLink.unknown": "Desconocido",
    "bioLink.untitled": "Sin título",
    "bioLink.uploadBgImage": "Subir imagen de fondo",
    "bioLink.uploadFailed": "Error al subir",
    "campaigns.approved": "Aprobado",
    "campaigns.approvedCount": "Aprobado",
    "campaigns.back": "Atrás",
    "campaigns.cancelled": "Cancelado",
    "campaigns.createNewCampaign": "Crear nueva campaña",
    "campaigns.createSuccess": "¡Campaña creada exitosamente!",
    "campaigns.date": "Fecha",
    "campaigns.newCampaign": "Nueva campaña",
    "campaigns.newPitchCampaign": "Nueva campaña de presentación",
    "campaigns.next": "Próximo",
    "campaigns.noCampaigns": "No se encontraron campañas",
    "campaigns.noCampaignsDesc": "No hay campañas que coincidan con estos filtros.",
    "campaigns.noMessage": "No se ha introducido ningún mensaje",
    "campaigns.pending": "Pendiente",
    "campaigns.pendingCount": "Pendiente",
    "campaigns.pitchMessage": "Mensaje de presentación",
    "campaigns.pitchPlaceholder": "Ej: Esta pista refleja la energía del verano...",
    "campaigns.reachPotential": "Llegar al bote.",
    "campaigns.rejected": "Rechazado",
    "campaigns.rejectedCount": "Rechazado",
    "campaigns.selectedRelease": "Lanzamiento seleccionado",
    "campaigns.startCampaign": "Iniciar campaña",
    "campaigns.step1Desc": "Seleccione la versión para la que desea crear una campaña.",
    "campaigns.step1Title": "1. Selección de lanzamiento",
    "campaigns.step2Desc": "Selecciona los curadores/listas de reproducción a los que deseas presentar tu lanzamiento.",
    "campaigns.step2Title": "2. Listas de reproducción objetivo",
    "campaigns.step3Desc": "Cuéntales brevemente a los curadores por qué deberían agregar tu canción a su lista de reproducción.",
    "campaigns.step3Title": "3. Mensaje de presentación",
    "campaigns.subtitle": "Administre y rastree sus aplicaciones de listas de reproducción",
    "campaigns.summaryTitle": "Resumen y confirmación",
    "campaigns.target": "Objetivo",
    "campaigns.targetPlaylists": "Listas de reproducción objetivo",
    "campaigns.title": "Campañas",
    "campaigns.totalApplications": "Aplicaciones totales",
    "canvasStudio.aiEffectsDesc": "Efectos visuales y filtros impulsados por IA",
    "canvasStudio.aiEffectsTitle": "Efectos de IA",
    "canvasStudio.aiVideoGenDesc": "Genera automáticamente vídeos musicales con IA",
    "canvasStudio.aiVideoGenTitle": "Generador de vídeo IA",
    "canvasStudio.audioVisDesc": "Visualización en tiempo real sincronizada con tu música.",
    "canvasStudio.audioVisTitle": "Visualizador de audio",
    "canvasStudio.autoSyncDesc": "Efectos visuales sincronizados automáticamente al ritmo.",
    "canvasStudio.autoSyncTitle": "Sincronización automática",
    "canvasStudio.canvasTempDesc": "Plantillas de animación profesionales para Spotify Canvas",
    "canvasStudio.canvasTempTitle": "Plantillas de lienzo",
    "canvasStudio.desc": "Canvas Studio se encuentra actualmente en mantenimiento. ¡Volverá pronto con herramientas poderosas!",
    "canvasStudio.maintenance": "En mantenimiento: nuevas funciones próximamente",
    "canvasStudio.motionGraphDesc": "Animaciones y gráficos en movimiento profesionales.",
    "canvasStudio.motionGraphTitle": "Gráficos en movimiento",
    "canvasStudio.notify": "Se le notificará cuando se actualice esta función",
    "canvasStudio.title": "Estudio de lienzo",
    "canvasStudio.upcoming": "Próximas funciones",
    "contributors.addNew": "Agregar nuevo",
    "contributors.release": "Lanzamiento",
    "contributors.pay": "Porcentaje",
    "contributors.invite": "Enviar invitación",
    "contributors.remove": "Eliminar",
    "contributors.allReleases": "Todos los lanzamientos",
    "contributors.allRoles": "Todos los roles",
    "contributors.desc": "Administre su equipo, socios y divisiones de regalías.",
    "contributors.empty.desc": "Nadie coincide con tus criterios de búsqueda o aún no has agregado a nadie.",
    "contributors.empty.title": "No se encontraron contribuyentes",
    "contributors.errors.fillFields": "Por favor complete todos los campos requeridos.",
    "contributors.modal.cancel": "Cancelar",
    "contributors.modal.email": "Correo electrónico",
    "contributors.modal.name": "Nombre completo",
    "contributors.modal.release": "Versión asociada (opcional)",
    "contributors.modal.role": "Rol",
    "contributors.modal.save": "Guardar",
    "contributors.modal.split": "División (%)",
    "contributors.modal.title": "Agregar nuevo colaborador",
    "contributors.searchPlaceholder": "Buscar por nombre o correo electrónico...",
    "contributors.stats.avgSplit": "División promedio",
    "contributors.stats.commonRole": "Rol más común",
    "contributors.stats.total": "Total de contribuyentes",
    "contributors.success.added": "¡Colaborador agregado exitosamente!",
    "contributors.success.deleted": "Colaborador eliminado.",
    "contributors.success.invited": "¡Invitación enviada!",
    "contributors.title": "Colaboradores",
    "feature.disabled": "Función deshabilitada",
    "feature.disabledDesc": "El administrador ha desactivado esta función para su cuenta. Póngase en contacto con el soporte para obtener más información.",
    "lyrics.aiGenerate": "Generar IA",
    "lyrics.aiGenerating": "Generando...",
    "lyrics.desc": "Gestiona, sincroniza y traduce tus letras.",
    "lyrics.editorSubtitle": "Editor de letras",
    "lyrics.empty.notFound": "No se encontraron pistas",
    "lyrics.emptyState.desc": "Seleccione una pista de la izquierda para comenzar a editar.",
    "lyrics.emptyState.title": "Administra tus letras",
    "lyrics.errors.aiFailed": "Error al generar letras.",
    "lyrics.errors.loadFailed": "Error al cargar datos.",
    "lyrics.errors.noLyrics": "No hay letras para exportar",
    "lyrics.errors.saveFailed": "Error al guardar.",
    "lyrics.errors.selectTrack": "Por favor seleccione una pista",
    "lyrics.export": "Exportar",
    "lyrics.labels.originalLang": "Idioma original",
    "lyrics.labels.translationLang": "Traducción (inglés)",
    "lyrics.placeholders.editor": "Escribe tus letras aquí...",
    "lyrics.placeholders.translation": "Escribe la traducción aquí...",
    "lyrics.save": "Guardar",
    "lyrics.searchPlaceholder": "Buscar una pista o lanzamiento...",
    "lyrics.stats.completion": "Finalización",
    "lyrics.stats.totalTracks": "Total de pistas",
    "lyrics.success.aiGenerated": "¡Letras de IA generadas!",
    "lyrics.success.downloaded": "descargado!",
    "lyrics.success.saved": "Letras guardadas!",
    "lyrics.success.updated": "¡Letras actualizadas!",
    "lyrics.synced.desc": "¡Muy pronto! Podrás cronometrar cada línea mientras suena tu canción.",
    "lyrics.synced.title": "Modo de letras sincronizadas",
    "lyrics.tabs.editor": "Editor de texto",
    "lyrics.tabs.synced": "Sincronización",
    "lyrics.tabs.translation": "Traducción",
    "lyrics.title": "Administrador de letras",
    "mastering.acoustic": "acústico",
    "mastering.additionalProcessing": "Procesamiento adicional",
    "mastering.advancedParams": "Parámetros avanzados",
    "mastering.aiAnalyzing": "La IA está analizando...",
    "mastering.aiDetected": "IA detectada",
    "mastering.aiRecommendations": "Recomendaciones de IA",
    "mastering.analysis": "Análisis",
    "mastering.analyzing": "Analizando...",
    "mastering.analyzingDesc": "Se están analizando características de audio, tempo, distribución de frecuencias...",
    "mastering.audioFeatures": "Funciones de audio",
    "mastering.bass": "Bajo (bajo)",
    "mastering.brightness": "Brillo",
    "mastering.broadcast": "Difusión",
    "mastering.broadcastDesc": "Estándares de TV/Radio (-23 LUFS)",
    "mastering.cdQuality": "Calidad de CD",
    "mastering.cdQualityDesc": "Ideal para lanzamiento físico (-12 LUFS)",
    "mastering.classical": "clásico",
    "mastering.clickToChangeFile": "MB: haga clic para elegir otro archivo",
    "mastering.clubDJ": "Discoteca/DJ",
    "mastering.clubDJDesc": "Para sistemas de sonido de discotecas (-10 LUFS)",
    "mastering.completed": "Completado",
    "mastering.compression": "Compresión",
    "mastering.confidence": "confianza",
    "mastering.creditDeducted": "Se deducirá 1 crédito maestro",
    "mastering.desc": "Masterización profesional automática con IA",
    "mastering.downloadFailed": "La descarga falló.",
    "mastering.downloadMaster": "Descargar Maestro",
    "mastering.downloading": "Descargando archivo masterizado!",
    "mastering.dragDrop": "Arrastrar y soltar",
    "mastering.dragDropClick": "Arrastra tu canción o haz clic",
    "mastering.dynamicRange": "Rango dinámico",
    "mastering.edm": "electroerosión",
    "mastering.energyDistribution": "Distribución de energía",
    "mastering.eq": "Ecualizador (EQ)",
    "mastering.errors.masterFailed": "Masterización fallida",
    "mastering.errors.uploadFailed": "Error al subir",
    "mastering.fileConstraints": "WAV, MP3, FLAC, AIFF • Máximo 100 MB",
    "mastering.flac": "FLAC",
    "mastering.flacDesc": "Compresión sin pérdidas",
    "mastering.format": "Formato",
    "mastering.genreAnalysis": "Análisis de género",
    "mastering.hiphop": "hip hop",
    "mastering.jazz": "jazz",
    "mastering.lofi": "baja fidelidad",
    "mastering.loudMaster": "Maestro ruidoso",
    "mastering.loudMasterDesc": "Alto volumen para máximo impacto (-8 LUFS)",
    "mastering.masterTrack": "Pista maestra",
    "mastering.mastered": "dominado",
    "mastering.masteringHistory": "Dominar la historia",
    "mastering.masteringPreset": "Preajuste de masterización",
    "mastering.masteringProcessing": "Dominar el procesamiento...",
    "mastering.metal": "metales",
    "mastering.metricsComp": "Comparación de métricas",
    "mastering.mixMastering": "Masterización de mezcla",
    "mastering.mp3_192": "MP3 192 kbps",
    "mastering.mp3_192Desc": "Calidad estándar",
    "mastering.mp3_320": "MP3 320 kbps",
    "mastering.mp3_320Desc": "Alta calidad, tamaño pequeño",
    "mastering.newFile": "Nuevo archivo",
    "mastering.noHistory": "Aún no hay historial de masterización.",
    "mastering.normal": "normales",
    "mastering.normalDesc": "Dominio de IA estándar",
    "mastering.optional": "(Opcional)",
    "mastering.original": "Original",
    "mastering.outputFormat": "Formato de salida",
    "mastering.podcast": "Pódcast",
    "mastering.pop": "pop",
    "mastering.preset": "Preestablecido",
    "mastering.processFailed": "La masterización de IA falló.",
    "mastering.processSuccess": "¡Dominación de IA completada!",
    "mastering.processing": "Procesamiento",
    "mastering.processingDesc": "Se están aplicando EQ, compresor, limitador, normalización de sonoridad...",
    "mastering.refTrackAiNote": "La IA analizará y aplicará el equilibrio tonal de esta pista.",
    "mastering.refTrackUploadDesc": "Sube una pista de referencia con tu perfil de sonido objetivo",
    "mastering.refTrackUploaded": "Pista de referencia cargada",
    "mastering.reference": "Referencia",
    "mastering.referenceTrack": "Pista de referencia",
    "mastering.resetToDefault": "Restablecer los valores predeterminados",
    "mastering.reverb": "reverberación",
    "mastering.reverbDesc": "Efecto de reverberación exuberante",
    "mastering.rnb": "R&B",
    "mastering.rock": "roca",
    "mastering.saturation": "Saturación",
    "mastering.selectEffect": "Seleccionar efecto",
    "mastering.selectTarget": "Seleccionar objetivo...",
    "mastering.slowed": "ralentizado",
    "mastering.slowedDesc": "Ralentizado (0,82x)",
    "mastering.slowedReverb": "Ralentizado + Reverberación",
    "mastering.slowedReverbDesc": "Lento + reverberación",
    "mastering.speedReverb": "Acelerar + Reverberación",
    "mastering.speedReverbDesc": "Rápido + reverberación",
    "mastering.speedUp": "Acelerar",
    "mastering.speedUpDesc": "Acelerado (1,25x)",
    "mastering.startAiMastering": "Comience a dominar la IA",
    "mastering.stepAnalyze": "Análisis de IA",
    "mastering.stepDone": "Completado",
    "mastering.stepProcess": "Procesamiento",
    "mastering.stepUpload": "Subir",
    "mastering.stereoWidth": "Ancho estéreo",
    "mastering.streaming": "Transmisión",
    "mastering.streamingDesc": "Optimizado para Spotify/Apple Music (-14 LUFS)",
    "mastering.subtitle": "Procesamiento manual de audio profesional.",
    "mastering.success.masteredDesc": "Tu pista está lista para descargar.",
    "mastering.success.masteredTitle": "¡Masterización completa!",
    "mastering.success.uploaded": "Archivo subido y analizado!",
    "mastering.title": "Dominio de la IA",
    "mastering.treble": "Agudos (altos)",
    "mastering.unsupportedFormat": "Formato de archivo no compatible.",
    "mastering.uploadFormat": "Sube tu mezcla sin masterizar (WAV, FLAC, MP3)",
    "mastering.uploadTrack": "Subir pista",
    "mastering.vinyl": "Vinilo",
    "mastering.vinylDesc": "Sensación analógica cálida que preserva el rango dinámico",
    "mastering.wav16": "WAV de 16 bits",
    "mastering.wav16Desc": "calidad de CD",
    "mastering.wav24": "WAV de 24 bits",
    "mastering.wav24Desc": "Máxima calidad, estándar de estudio",
    "playlistExplorer.addedToFavs": "Añadido a favoritos",
    "playlistExplorer.emptyDesc": "Utilice la barra de búsqueda de arriba para encontrar listas de reproducción.",
    "playlistExplorer.emptyTitle": "Buscar o utilizar filtros",
    "playlistExplorer.filters": "Filtros",
    "playlistExplorer.findSimilar": "Buscar similares",
    "playlistExplorer.followers": "Seguidores",
    "playlistExplorer.genre": "Género",
    "playlistExplorer.noFavs": "Aún no tienes una lista de reproducción favorita.",
    "playlistExplorer.platform": "Plataforma",
    "playlistExplorer.removedFromFavs": "Eliminado de favoritos",
    "playlistExplorer.risky": "Arriesgado",
    "playlistExplorer.saveSearch": "Guardar búsqueda",
    "playlistExplorer.search": "Buscar",
    "playlistExplorer.searchPlaceholder": "Busque una lista de reproducción, curador o palabra clave...",
    "playlistExplorer.subtitle": "Encuentra las listas de reproducción más adecuadas con filtros avanzados e IA",
    "playlistExplorer.tabExplore": "Explorar",
    "playlistExplorer.tabFavorites": "Favoritos",
    "playlistExplorer.tabSaved": "Búsquedas guardadas",
    "playlistExplorer.title": "Descubre listas de reproducción",
    "playlistExplorer.verified": "Verificado",
    "playlistExplorer.apply": "Solicitar",
    "playlistExplorer.applyTitle": "Solicitud de Playlist",
    "playlistExplorer.applySuccess": "¡Solicitud enviada exitosamente!",
    "playlistExplorer.applyError": "Error al enviar la solicitud",
    "playlistExplorer.selectRelease": "Seleccionar Lanzamiento",
    "playlistExplorer.pitchMessage": "Mensaje de Presentación (Opcional)",
    "playlistExplorer.pitchPlaceholder": "Mi canción encaja en esta playlist porque...",
    "playlistExplorer.sending": "Enviando...",
    "playlistExplorer.send": "Enviar",
    "playlistExplorer.loadingReleases": "Cargando lanzamientos...",
    "playlistExplorer.noReleases": "No se encontraron lanzamientos.",
    "preSave.appleMusicId": "ID de música de Apple",
    "preSave.applePlaceholder": "123456789",
    "preSave.spotifyPlaceholder": "spotify:álbum:...",
    "preSave.spotifyUri": "URI de Spotify",
    "promotions.artist": "Artista",
    "promotions.download": "Descargar",
    "promotions.downloadInstructions": "Haga clic en una tarjeta para descargar.",
    "promotions.downloading": "Descargando...",
    "promotions.generating": "Generando tarjetas de promoción...",
    "promotions.generatingWait": "Este proceso puede tardar unos segundos.",
    "promotions.noApprovedRelease": "Aún no hay lanzamientos aprobados",
    "promotions.noApprovedReleaseDesc": "Las tarjetas de promoción aparecerán aquí una vez que su lanzamiento esté disponible.",
    "promotions.noRelease": "Aún no hay lanzamientos publicados",
    "promotions.selectPlaceholder": "Seleccione una versión...",
    "promotions.selectReleaseDesc": "Crea imágenes llamativas con plantillas.",
    "promotions.selectReleasePrompt": "Seleccione un lanzamiento para ver las tarjetas de promoción",
    "promotions.statusApproved": "Aprobado",
    "promotions.statusLive": "Vivir",
    "promotions.subtitle": "Seleccione su lanzamiento y descargue tarjetas promocionales en alta resolución.",
    "promotions.title": "Tarjetas de promoción",
    "promotions.untitled": "Sin título",
    "promotions.untitledTrack": "Pista sin título",
    "qr.cancel": "Cancelar",
    "qr.createError": "No se pudo crear el código QR",
    "qr.createSuccess": "Código QR creado exitosamente",
    "qr.deleteError": "No se pudo eliminar el código QR",
    "qr.deleteSuccess": "Código QR eliminado con éxito",
    "qr.fetchError": "No se pudieron recuperar los códigos QR",
    "qr.formTitle": "Título",
    "qr.requiredFields": "El título y la URL son obligatorios.",
    "qr.subtitle": "Cree y administre códigos QR personalizados para su contenido",
    "qr.titlePlaceholder": "p.ej. Gira de verano 2024",
    "smartLinks.basicInfo": "Información básica",
    "smartLinks.customSlug": "Babosa personalizada",
    "smartLinks.slugPlaceholder": "mi-nuevo-single",
    "smartLinks.titlePlaceholder": "p.ej. Mi nuevo sencillo",
    "splits.accept": "Aceptar",
    "splits.activeSplits": "Divisiones activas",
    "splits.chooseLiveRelease": "Elige un lanzamiento en vivo",
    "splits.contributing": "Contribuyendo",
    "splits.contributingTo": "Contribuyendo a dividir",
    "splits.createBtn": "Crear nueva división",
    "splits.createModalDesc": "Seleccione un lanzamiento en vivo para crear una división de ingresos",
    "splits.createModalTitle": "Crear división de ingresos",
    "splits.currentBalance": "Saldo actual",
    "splits.decline": "Rechazar",
    "splits.earningsByTrack": "Ganancias por pista",
    "splits.errorCreate": "No se pudo crear la división",
    "splits.errorLoad": "No se pudieron cargar los datos de divisiones",
    "splits.errorNoTrack": "No se encontró ninguna pista en esta versión.",
    "splits.errorRespond": "No se pudo responder",
    "splits.errorSelectRelease": "Por favor seleccione una versión",
    "splits.from": "De:",
    "splits.inviteAccepted": "¡Invitación aceptada!",
    "splits.inviteDeclined": "Invitación rechazada",
    "splits.live": "en vivo",
    "splits.mySplits": "mis divisiones",
    "splits.noContributingSplits": "Aún no estás contribuyendo a ninguna división.",
    "splits.noContributingSplitsDesc": "Acepta invitaciones de otros artistas para empezar a ganar.",
    "splits.noLiveReleases": "Necesita al menos un lanzamiento en vivo para crear divisiones de ingresos.",
    "splits.noOwnedSplits": "Aún no has creado ninguna división de ingresos.",
    "splits.noOwnedSplitsDesc": "Agregue colaboradores al cargar una pista para compartir los ingresos.",
    "splits.onlyLiveReleases": "Sólo los lanzamientos en vivo pueden tener divisiones de ingresos.",
    "splits.owner": "Propietario:",
    "splits.pendingInvitations": "Invitaciones pendientes",
    "splits.pendingInvitationsDesc": "Tienes invitaciones pendientes de división de ingresos",
    "splits.roleContributor": "Colaborador",
    "splits.roleFeaturedArtist": "Artista destacado",
    "splits.roleProducer": "Productor",
    "splits.roleSongwriter": "Compositor",
    "splits.selectRelease": "Seleccione Lanzamiento *",
    "splits.subtitle": "Gestionar el reparto de ingresos con los colaboradores",
    "splits.successCreated": "¡La división de ingresos se creó correctamente!",
    "splits.title": "División de ingresos",
    "splits.totalEarned": "Total ganado",
    "splits.trackId": "ID de pista:",
    "splits.trackSplit": "División de pista",
    "splits.untitled": "Intitulado",
    "splits.you": "(tú)",
    "splits.yourShare": "Tu parte",
    "subscription.advanced": "Avanzado",
    "subscription.artistDesc": "Para artistas serios",
    "subscription.basic": "Básico",
    "subscription.choosePlan": "Elige tu plan",
    "subscription.commission": "Comisión",
    "subscription.contactSupport": "Póngase en contacto con nuestro equipo de soporte si tiene alguna pregunta.",
    "subscription.contactSupportBtn": "Contactar con soporte",
    "subscription.currentPlan": "Plan actual:",
    "subscription.currentPlanBtn": "Plan actual",
    "subscription.days25": "2-5 días",
    "subscription.downgrade": "Rebajar",
    "subscription.email": "Correo electrónico",
    "subscription.fastDelivery": "Entrega rápida",
    "subscription.featAnalytics": "Analítica",
    "subscription.featCommission": "Tasa de comisión",
    "subscription.featDelivery": "Tiempo de entrega",
    "subscription.featMultiArtist": "Múltiples artistas",
    "subscription.featReleaseLimit": "Límite de liberación",
    "subscription.featSplits": "Sistema dividido",
    "subscription.featSupport": "Soporte",
    "subscription.feature": "Característica",
    "subscription.featureComparison": "Comparación de características",
    "subscription.free": "Gratis",
    "subscription.freeDesc": "Comienza tu viaje musical",
    "subscription.haveQuestions": "¿Tiene preguntas?",
    "subscription.hours2472": "24-72 horas",
    "subscription.labelDesc": "Para sellos y managers",
    "subscription.month": "mes",
    "subscription.paymentSoon": "¡La integración de pagos próximamente! Póngase en contacto con el soporte para actualizar.",
    "subscription.popular": "populares",
    "subscription.priority": "Prioridad",
    "subscription.release": "Lanzamiento",
    "subscription.save17": "ahorrar 17%",
    "subscription.subtitle": "Elige el plan que se ajuste a tus necesidades.",
    "subscription.title": "Haz crecer tu carrera musical",
    "subscription.unlimited": "Ilimitado",
    "subscription.upgrade": "Actualizar",
    "subscription.year": "año",
    "subscription.yearlyOr": "o",
    "viral.activeCampaigns": "Campañas activas",
    "viral.activeCampaignsList": "Campañas activas",
    "viral.aiPlanning": "La IA está planificando...",
    "viral.aiPlanningDesc": "Se está creando la mejor estrategia viral.",
    "viral.back": "Atrás",
    "viral.campaignCreateError": "Error al crear la campaña.",
    "viral.campaignLive": "¡La campaña está activa!",
    "viral.campaignLiveDesc": "Su campaña fue creada exitosamente.",
    "viral.campaignPage": "Página de campaña",
    "viral.campaignSuccess": "¡Campaña lanzada con éxito!",
    "viral.cancel": "Cancelar",
    "viral.clicks": "Clics",
    "viral.contentCount": "Recuento de contenido",
    "viral.contentIdeas": "Ideas de contenido",
    "viral.continue": "Continuar",
    "viral.copied": "copiado",
    "viral.copy": "Copiar",
    "viral.createAIPlan": "Generar plan de IA",
    "viral.createNewCampaign": "Crear nueva campaña",
    "viral.desc": "Cree planes de marketing y participación paso a paso impulsados ​​por IA.",
    "viral.engagementRate": "Tasa de participación",
    "viral.estReach": "Alcance estimado",
    "viral.globalImpactMap": "Mapa de impacto global",
    "viral.hashtagDesc": "Construya una comunidad en torno a una etiqueta específica",
    "viral.hashtagName": "Campaña de hashtags",
    "viral.launchCampaign": "Campaña de lanzamiento",
    "viral.launching": "Lanzamiento",
    "viral.linkCopied": "Enlace copiado!",
    "viral.listeningDesc": "Evento de escucha en línea sincrónico con fans",
    "viral.listeningName": "Fiesta de escucha",
    "viral.noActiveCampaigns": "Aún no hay campañas activas.",
    "viral.noActiveCampaignsDesc": "Utilice el asistente para crear su primera campaña.",
    "viral.noReleases": "Aún no tienes ninguna versión aprobada.",
    "viral.noReleasesDesc": "Primero cree un lanzamiento para iniciar una campaña.",
    "viral.planError": "Error al generar plan",
    "viral.platformLinks": "Enlaces de plataforma",
    "viral.platformLinksDesc": "Ingresa los enlaces donde los oyentes accederán a tu canción.",
    "viral.presaveDesc": "Haz que los oyentes guarden previamente tu lanzamiento",
    "viral.presaveName": "Campaña de pre-guardado",
    "viral.progress": "Progreso",
    "viral.release": "Lanzamiento",
    "viral.selectCampaignType": "Seleccione el tipo de campaña",
    "viral.selectCampaignTypeDesc": "Determina la estrategia de marketing que mejor se adapta a tu objetivo.",
    "viral.selectRelease": "Seleccionar lanzamiento objetivo",
    "viral.selectReleaseDesc": "¿Para qué canción quieres crear una campaña?",
    "viral.stepAIPlan": "Plan de IA",
    "viral.stepLaunch": "Lanzamiento",
    "viral.stepRelease": "Lanzamiento",
    "viral.stepType": "Tipo",
    "viral.task": "Tarea",
    "viral.teaserDesc": "Una serie de intrigantes contenidos previos al lanzamiento.",
    "viral.teaserName": "Avance",
    "viral.tiktokDesc": "Involucrar a los usuarios con un baile o una tendencia",
    "viral.tiktokName": "Desafío de TikTok",
    "viral.timeline": "Línea de tiempo",
    "viral.title": "Campaña viral",
    "viral.totalCampaigns": "Campañas totales",
    "viral.totalViews": "Vistas totales",
    "viral.unknownRelease": "Lanzamiento desconocido",
    "viral.viewCampaignPage": "Ver página de campaña",
    "viral.views": "Vistas",

  
  
  
    "email.subject_placeholder": "Asunto...",
    "social.error_content_required": "El contenido es obligatorio",
    "copyright.analyzing": "Analizando...",
    "copyright.totalScans": "Escaneos Totales",
    "email.name_placeholder": "Nombre...",
    "lyricsSync.lyricsPlaceholder": "Introduce las letras aquí línea por línea...",
    "social.create_first": "Crear Primera Publicación",
    "email.error_deleting_subscriber": "Error al eliminar el suscriptor",
    "email.campaign_created": "Campaña creada",
    "copyright.supportedFormats": "Formatos Soportados",
    "preSave.requiredFields": "Por favor, completa todos los campos requeridos",
    "email.subscriber_deleted": "Suscriptor eliminado",
    "preSave.confirmDelete": "¿Estás seguro de que deseas eliminar esta campaña?",
    "social.error_delete": "Error al eliminar la publicación",
    "email.email_placeholder": "Correo electrónico...",
    "releases.fetchFailed": "Error al obtener lanzamientos",
    "email.fill_required": "Por favor, completa todos los campos requeridos",
    "toast.releaseSubmitFailed": "Error al enviar el lanzamiento",
    "preSave.fetchError": "Error al cargar datos",
    "_": "_",
    "email.click_rate": "Tasa de Clics",
    "common.saving": "Guardando...",
    "aiStudio.alreadyAnalyzed": "Este archivo ya ha sido analizado",
    "email.subscribers_list": "Lista de Suscriptores",
    "copyright.recentScans": "Escaneos Recientes",
    ".": ".",
    "support.faq": "Preguntas Frecuentes",
    "email.add": "Añadir",
    "pressKit.success.upload": "Cargado con éxito",
    "email.status": "Estado",
    "copyright.startScanBtn": "Iniciar Escaneo",
    "error": "Error",
    "contributors.errors.deleteFailed": "Error al eliminar contribuyente",
    "support.submit": "Enviar",
    "album": "Álbum",
    "email.error_creating_campaign": "Error al crear la campaña",
    "email.no_subscribers": "Sin suscriptores",
    "releases.deleteSuccess": "Lanzamiento eliminado con éxito",
    "referrals.error": "Error de referencia",
    "common.title": "Título",
    "social.confirm_delete": "¿Estás seguro de que deseas eliminar?",
    "pressKit.subtitle": "Kit de Prensa Electrónico",
    "pressKit.error.maxPhotos": "Número máximo de fotos alcanzado",
    "email.error_adding_subscriber": "Error al añadir suscriptor",
    "email.error_fetching": "Error al obtener datos",
    "social.updated": "Actualizado con éxito",
    "promotions.errorGenerating": "Error al generar tarjetas de promoción",
    "collab.cancel": "Cancelar",
    "common.yesDelete": "Sí, Eliminar",
    "social.empty_desc": "No se encontraron publicaciones",
    "common.continue": "Continuar",
    "email.campaign_sent": "Campaña enviada",
    "SRT": "SRT",
    "email.email": "Correo",
    "pressKit.error.upload": "Error al cargar",
    "TXT": "TXT",
    "social.error_upload": "Error al cargar medios",
    "campaigns.all": "Todas las Campañas",
    "copyright.error.noFile": "Ningún archivo seleccionado",
    "ref": "Referencia",
    "common.select": "Seleccionar",
    "copyright.scanStarted": "Escaneo iniciado",
    "social.status": "Estado",
    "copyright.noDetails": "Sin detalles disponibles",
    "script": "Script",
    "lyricsSync.description": "Crea letras sincronizadas en el tiempo para tus canciones",
    "aiStudio.maintenanceDesc": "Esta función está actualmente en mantenimiento. Estará disponible pronto.",
    "lyricsSync.previewEmpty": "La vista previa aparecerá aquí",
    "aiAdvisor.exportFileName": "exportar_asesor",
    "copyright.uploadFile": "Subir Archivo",
    "email.import_error": "Error al importar",
    "error.fetch": "Error de obtención",
    "copyright.subtitle": "Gestión de Derechos de Autor",
    "wizard.moreOptions.ownershipConfirmation": "Confirmación de Propiedad",
    "social.media": "Redes Sociales",
    "lyricsSync.saveSuccess": "Letras Guardadas con Éxito",
    "common.verifying": "Verificando...",
    "preSave.deleteError": "Error al eliminar la campaña",
    "smartLinks.uploadCover": "Haz clic para subir imagen de portada",
    "lyricsSync.selectTrackLabel": "Seleccionar Pista",
    "smartLinks.uploadBg": "Subir imagen de fondo (opcional)",
    "lyricsSync.noAudio": "No se encontró audio para esta pista. La sincronización podría no funcionar correctamente.",
    "social.error_save": "Error al guardar la publicación",
    "support.attachments": "Archivos Adjuntos",
    "common.or": "O",
    "email.no_campaigns": "Sin campañas",
    "email.import_success": "Importado con éxito",
    "pressKit.error.load": "Error al cargar el kit de prensa",
    "pressKit.assets": "Activos",
    "promotions.downloadError": "Error al descargar",
    "preSave.copied": "Copiado",
    "email.total_subscribers": "Total de Suscriptores",
    "pressKit.noReleases": "Sin lanzamientos",
    "email.save_draft": "Guardar Borrador",
    "preSave.createFirst": "Crear Primera Campaña",
    "copyright.cleanDesc": "Descripción de pista limpia",
    "preSave.createSuccess": "Campaña creada con éxito",
    "lyricsSync.allSynced": "¡Todas las líneas sincronizadas!",
    "copyright.error.noTrack": "Ninguna pista seleccionada",
    "lyricsSync.saveError": "Error al Guardar Letras",
    "playlistExplorer.all": "Todas las Listas de Reproducción",
    "contributors.errors.loadFailed": "Error al cargar contribuyentes",
    "pressKit.error.save": "Error al guardar el kit de prensa",
    "email.error_sending_campaign": "Error al enviar la campaña",
    "releaseForm.selectGenre": "Seleccionar Género",
    "playlistExplorer.errorFetching": "Error al obtener listas",
    "aiStudio.maintenance": "En Mantenimiento",
    "social.error_fetch": "Error al obtener publicaciones",
    "none": "Ninguno",
    "smartLinks.error.fetch": "Error al obtener enlaces inteligentes",
    "preSave.deleteSuccess": "Campaña eliminada",
    "social.editPost": "Editar Publicación",
    "promotions.downloadSuccess": "¡Tarjeta de promoción descargada!",
    "smartLinks.error.create": "Error al crear enlace inteligente",
    "contributors.errors.saveFailed": "Error al guardar contribuyente",
    "smartLinks.confirm.delete": "¿Estás seguro de que deseas eliminar este enlace inteligente?",
    "email.error_deleting_campaign": "Error al eliminar la campaña",
    "email.date": "Fecha",
    "social.error_platform_required": "Se requiere plataforma",
    "smartLinks.error.required": "El título y el slug son requeridos",
    "social.created": "Publicación creada",
    "2d": "2D",
    "copyright.chooseTrack": "Elegir Pista",
    "social.error_date_required": "Se requiere fecha",
    "copyright.scanFailed": "Escaneo fallido",
    "copyright.flaggedTracks": "Pistas Marcadas",
    "pressKit.bioPlaceholder": "Biografía...",
    "status.pending": "Pendiente",
    "social.deleted": "Publicación eliminada",
    "email.create_campaign": "Crear Campaña",
    "smartLinks.success.created": "Enlace inteligente creado con éxito",
    "T": "T",
    "canvas": "Lienzo",
    "email.actions": "Acciones",
    "smartLinks.error.delete": "Error al eliminar enlace inteligente",
    "a": "a",
    "support.guides": "Guías",
    "social.image_uploaded": "Imagen subida",
    "pressKit.success.save": "Guardado con éxito",
    "email.open_rate": "Tasa de Apertura",
    "preSave.chooseRelease": "Elegir lanzamiento...",
    "support.searchTickets": "Buscar entradas...",
    "copyright.startNewScan": "Iniciar Nuevo Escaneo",
    "copyright.dragDrop": "Arrastrar y Soltar",
    "single": "Sencillo",
    "email.content_placeholder": "Contenido...",
    "preSave.createError": "Error al crear la campaña",
    "-": "-",
    "email.campaign_deleted": "Campaña eliminada",
    "token": "Token",
    "playlistExplorer.apply": "Aplicar",
    "common.verify": "Verificar",
    "smartLinks.success.deleted": "Enlace inteligente eliminado",
    "wizard.moreOptions.contentIdTerms": "Términos de Content ID",
    "social.subtitle": "Panel de Redes Sociales",
    "status.scheduled": "Programado",
    "copyright.cleanRate": "Tasa de Limpieza",
    "email.subscriber_added": "Suscriptor añadido",
    "fanScore.fetchError": "Error al obtener puntuación de fans",
    "LRC": "LRC",
    // admin.announcements
    "admin.announcements.title": "Anuncios",
    "admin.announcements.subtitle": "Gestionar los anuncios mostrados a los usuarios",
    "admin.announcements.newAnnouncement": "Nuevo Anuncio",
    "admin.announcements.noAnnouncements": "Aún no hay anuncios",
    "admin.announcements.titleBodyRequired": "El título y el contenido son obligatorios",
    "admin.announcements.updated": "Anuncio actualizado",
    "admin.announcements.operationFailed": "Operación fallida",
    "admin.announcements.deleted": "Anuncio eliminado",
    "admin.announcements.deleteFailed": "Error al eliminar",
    "admin.announcements.deactivated": "Anuncio desactivado",
    "admin.announcements.activated": "Anuncio activado",
    "admin.announcements.active": "Activo",
    "admin.announcements.inactive": "Inactivo",
    "admin.announcements.createdAt": "Creado",
    "admin.announcements.start": "Inicio",
    "admin.announcements.end": "Fin",
    "admin.announcements.deactivate": "Desactivar",
    "admin.announcements.activate": "Activar",
    "admin.announcements.titleLabel": "Título",
    "admin.announcements.titlePlaceholder": "Título del anuncio",
    "admin.announcements.contentLabel": "Contenido",
    "admin.announcements.contentPlaceholder": "Contenido del anuncio",
    "admin.announcements.type": "Tipo",
    "admin.announcements.typeInfo": "Información",
    "admin.announcements.typeWarning": "Advertencia",
    "admin.announcements.typeSuccess": "Éxito",
    "admin.announcements.displayMode": "Modo de Visualización",
    "admin.announcements.both": "Ambos",
    "admin.announcements.startDateOptional": "Fecha de Inicio (opcional)",
    "admin.announcements.endDateOptional": "Fecha de Fin (opcional)",
    "admin.announcements.pinned": "Fijado",
    "admin.announcements.activeLabel": "Activo",

    // admin.aiMatcher
    "admin.aiMatcher.title": "Resultados de AI Matcher",
    "admin.aiMatcher.subtitle": "Historial de coincidencias de AI Playlist Matcher de los usuarios",
    "admin.aiMatcher.totalResults": "Total",
    "admin.aiMatcher.results": "resultados",
    "admin.aiMatcher.noResults": "Aún no hay resultados de coincidencia",
    "admin.aiMatcher.resultDeleted": "Resultado eliminado",
    "admin.aiMatcher.resultDeleteFailed": "Error al eliminar el resultado",
    "admin.aiMatcher.user": "Usuario",
    "admin.aiMatcher.release": "Lanzamiento",
    "admin.aiMatcher.genre": "Género",
    "admin.aiMatcher.match": "Coincidencia",
    "admin.aiMatcher.score": "Puntuación",
    "admin.aiMatcher.date": "Fecha",
    "admin.aiMatcher.actions": "Acciones",
    "admin.aiMatcher.matchedPlaylists": "Playlists Coincidentes",
    "admin.aiMatcher.followers": "seguidores",
    "admin.releaseDetail.fetchFailed": "Error al obtener detalles del lanzamiento",
    "admin.releaseDetail.reasonNeeded": "Se requiere un motivo para este estado",
    "admin.releaseDetail.statusUpdated": "Estado actualizado",
    "admin.releaseDetail.updateFailed": "Actualización fallida",
    "admin.releaseDetail.codesSaved": "Códigos guardados",
    "admin.releaseDetail.saveFailed": "Error al guardar",
    "admin.releaseDetail.packageDownloading": "Descargando paquete...",
    "admin.releaseDetail.releaseUpdated": "Lanzamiento actualizado",
    "admin.releaseDetail.metadataDownloaded": "Metadatos descargados",
    "admin.releaseDetail.dspSummary": "Resumen DSP",
    "admin.releaseDetail.editAll": "Editar Todo",
    "admin.releaseDetail.changeStatus": "Cambiar Estado",
    "admin.releaseDetail.updateStatus": "Actualizar Estado",
    "admin.releaseDetail.selectTemplate": "Seleccionar Plantilla",
    "admin.releaseDetail.templatePlaceholder": "Seleccionar plantilla o escribir mensaje personalizado...",
    "admin.releaseDetail.templateHint": "Si selecciona una plantilla, el mensaje se completará automáticamente y podrá editarlo.",
    "admin.releaseDetail.update": "Actualizar",
    "admin.releaseDetail.editCodes": "Editar Códigos ISRC y UPC",
    "admin.releaseDetail.upcCode": "UPC (Código de Lanzamiento)",
    "admin.releaseDetail.enterUpc": "Ingrese el código UPC",
    "admin.releaseDetail.barcodeHint": "Número de código de barras de 12 dígitos",
    "admin.releaseDetail.isrcCodes": "Códigos ISRC (Por Pista)",
    "admin.releaseDetail.enterIsrc": "Ingrese código ISRC (ej.: USRC17607839)",
    "admin.releaseDetail.isrcFormat": "Formato ISRC: CC-XXX-YY-NNNNN",
    "admin.releaseDetail.editRelease": "Editar Lanzamiento",
    "admin.releaseDetail.general": "General",
    "admin.releaseDetail.tracks": "Pistas",
    "admin.releaseDetail.publishing": "Publicación",
    "admin.releaseDetail.platforms": "Plataformas",
    "admin.releaseDetail.links": "Enlaces",
    "admin.releaseDetail.releaseType": "Tipo de Lanzamiento",
    "admin.releaseDetail.releaseDate": "Fecha de Lanzamiento",
    "admin.releaseDetail.albumTitle": "Título del Álbum",
    "admin.releaseDetail.albumVersion": "Versión del Álbum",
    "admin.releaseDetail.versionPlaceholder": "Deluxe, Remasterizado, etc.",
    "admin.releaseDetail.primaryGenre": "Género Principal",
    "admin.releaseDetail.secondaryGenre": "Género Secundario",
    "admin.releaseDetail.language": "Idioma",
    "admin.releaseDetail.labelCompany": "Sello / Compañía",
    "admin.releaseDetail.barcodeShort": "Código de barras de 12 dígitos",
    "admin.releaseDetail.barcodePlaceholder": "Código de barras de 12 dígitos",
    "admin.releaseDetail.releaseTime": "Hora de Lanzamiento",
    "admin.releaseDetail.select": "Seleccionar",
    "admin.releaseDetail.localTime": "Hora Local",
    "admin.releaseDetail.previouslyReleased": "Publicado anteriormente",
    "admin.releaseDetail.originalReleaseDate": "Fecha de Lanzamiento Original",
    "admin.releaseDetail.untitledTrack": "Pista Sin Título",
    "admin.releaseDetail.trackTitle": "Título de Pista",
    "admin.releaseDetail.version": "Versión",
    "admin.releaseDetail.versionExamples": "Remix, Acústico, etc.",
    "admin.releaseDetail.albumVersionPlaceholder": "Deluxe, Remasterizado, etc.",
    "admin.releaseDetail.contentType": "Tipo de Contenido",
    "admin.releaseDetail.notSpecified": "No especificado",
    "admin.releaseDetail.primaryArtistsComma": "Artistas Principales (separados por coma)",
    "admin.releaseDetail.featuredArtistsComma": "Artistas Destacados (separados por coma)",
    "admin.releaseDetail.spotifyArtistIds": "IDs de Artista en Spotify",
    "admin.releaseDetail.primaryArtists": "Artistas Principales",
    "admin.releaseDetail.spotifyIdNotLinked": "Spotify ID no vinculado - Artistas",
    "admin.releaseDetail.featuredArtists": "Artistas Destacados",
    "admin.releaseDetail.writers": "Escritores",
    "admin.releaseDetail.composers": "Compositores",
    "admin.releaseDetail.producers": "Productores",
    "admin.releaseDetail.songwritersFormat": "Compositores (Nombre (Rol), formato)",
    "admin.releaseDetail.contributors": "Contribuidores",
    "admin.releaseDetail.productionTeam": "Equipo de Producción",
    "admin.releaseDetail.instrumental": "Instrumental",
    "admin.releaseDetail.licensedContent": "Contenido Licenciado",
    "admin.releaseDetail.lyrics": "Letras",
    "admin.releaseDetail.enterLyrics": "Ingrese las letras...",
    "admin.releaseDetail.lyricsPlaceholder": "Ingrese las letras...",
    "admin.releaseDetail.publishingInfo": "Información de Publicación",
    "admin.releaseDetail.publishingPercentage": "Porcentaje de Publicación (%)",
    "admin.releaseDetail.hasPublisher": "Tengo un editor",
    "admin.releaseDetail.publisherName": "Nombre del Editor",
    "admin.releaseDetail.proInfo": "Información PRO",
    "admin.releaseDetail.registeredWithPro": "Registrado en PRO",
    "admin.releaseDetail.affiliatedSociety": "Sociedad Afiliada",
    "admin.releaseDetail.ipiNumber": "Número IPI",
    "admin.releaseDetail.distributionPlatforms": "Plataformas de Distribución",
    "admin.releaseDetail.platformLinks": "Enlaces de Plataforma",
    "admin.releaseDetail.dspDescription": "Toda la información de metadatos de pistas. Usar para carga manual en DSP.",
    "admin.releaseDetail.dspMetadataDesc": "Toda la información de metadatos de pistas. Usar para carga manual en DSP.",
    "admin.releaseDetail.releaseVersion": "Versión del Lanzamiento",
    "admin.releaseDetail.albumArtists": "Artistas del Álbum",
    "admin.releaseDetail.date": "Fecha",
    "admin.releaseDetail.trackCount": "Número de Pistas",
    "admin.releaseDetail.transferInfo": "Información de Transferencia",
    "admin.releaseDetail.distributionType": "Tipo de Distribución",
    "admin.releaseDetail.transferFrom": "Transferencia (De Otro Distribuidor)",
    "admin.releaseDetail.transferDistribution": "Transferencia (De Otro Distribuidor)",
    "admin.releaseDetail.newRelease": "Nuevo Lanzamiento",
    "admin.releaseDetail.trackVersion": "Versión de Pista",
    "admin.releaseDetail.existingIsrc": "ISRC Existente",
    "admin.releaseDetail.fileName": "Nombre de Archivo",
    "admin.releaseDetail.duration": "Duración",
    "admin.releaseDetail.trackVersionFull": "Versión de Pista",
    "admin.releaseDetail.trackLanguage": "Idioma de Pista",
    "admin.releaseDetail.titleLanguage": "Idioma del Título",
    "admin.releaseDetail.genre": "Género",
    "admin.releaseDetail.recordLabel": "Sello Discográfico",
    "admin.releaseDetail.credits": "Créditos",
    "admin.releaseDetail.creditInfo": "Créditos",
    "admin.releaseDetail.songwriters": "Compositores / Letristas",
    "admin.releaseDetail.songwritersSection": "Compositores / Letristas",
    "admin.releaseDetail.name": "Nombre",
    "admin.releaseDetail.role": "Rol",
    "admin.releaseDetail.productionTeamFull": "Equipo de Producción",
    "admin.releaseDetail.productionTeamSection": "Equipo de Producción",
    "admin.releaseDetail.contributorsFull": "Contribuidores",
    "admin.releaseDetail.contributorsSection": "Contribuidores",
    "admin.releaseDetail.noCreditWarning": "No se ingresó información de créditos para esta pista",
    "admin.releaseDetail.writersLegacy": "Escritores (Legacy)",
    "admin.releaseDetail.composersLegacy": "Compositores (Legacy)",
    "admin.releaseDetail.producersLegacy": "Productores (Legacy)",
    "admin.releaseDetail.downloadLicense": "Descargar Licencia (PDF)",
    "admin.releaseDetail.licenseNotUploaded": "¡Documento de licencia no cargado!",
    "admin.releaseDetail.noLicenseUploaded": "¡Documento de licencia no cargado!",
    "admin.releaseDetail.lyricsLanguage": "Idioma",
    "admin.releaseDetail.viewLyrics": "Ver Letras",
    "admin.releaseDetail.noLyricsEntered": "No se ingresaron letras",
    "admin.releaseDetail.lyricsDspNote": "Las letras pueden mostrarse en DSPs como Apple Music, Spotify, etc.",
    "admin.releaseDetail.lyricsVisibleOnDsp": "Las letras pueden mostrarse en DSPs como Apple Music, Spotify, etc.",
    "admin.releaseDetail.noTracks": "No hay pistas",
    "admin.releaseDetail.contributorsTitle": "Contribuidores",
    "admin.releaseDetail.producersLabel": "Productores",
    "admin.releaseDetail.platformsTitle": "Plataformas",
    "admin.releaseDetail.images": "Imágenes",
    "admin.releaseDetail.coverImages": "Imágenes",
    "admin.releaseDetail.linksTitle": "Enlaces",
    "admin.releaseDetail.pricing": "Precios",
    "admin.releaseDetail.singlePrice": "Precio Individual",
    "admin.releaseDetail.albumPrice": "Precio del Álbum",
    "admin.releaseDetail.uploadDate": "Subida",
    "admin.artists.loadFailed": "Error al cargar detalles del usuario",
    "admin.artists.featureUpdated": "Función actualizada",
    "admin.artists.featureUpdateFailed": "Error al actualizar función",
    "admin.artists.ibanRevealed": "IBAN revelado - Registrado en log de auditoría",
    "admin.artists.ibanNotFound": "Información de IBAN no encontrada",
    "admin.artists.superadminRequired": "Se requiere permiso de superadmin",
    "admin.artists.ibanRevealFailed": "Error al revelar IBAN",
    "admin.artists.copiedToClipboard": "Copiado al portapapeles",
    "admin.artists.userApproved": "Usuario aprobado",
    "admin.artists.rejectReasonMandatory": "El motivo de rechazo es obligatorio",
    "admin.artists.rejectReasonRequired": "El motivo de rechazo es obligatorio",
    "admin.artists.userRejected": "Usuario rechazado",
    "admin.artists.banReasonMandatory": "El motivo de ban es obligatorio",
    "admin.artists.banReasonRequired": "El motivo de ban es obligatorio",
    "admin.artists.userBanned": "Usuario baneado",
    "admin.artists.banRemoved": "Ban eliminado",
    "admin.artists.planUpdated": "Plan actualizado",
    "admin.artists.badgesUpdated": "Insignias actualizadas",
    "admin.artists.enterValidAmount": "Ingrese un monto válido",
    "admin.artists.addedByAdmin": "Agregado por admin",
    "admin.artists.balanceUpdated": "Saldo actualizado",
    "admin.artists.operationFailed": "Operación fallida",
    "admin.artists.passwordMinLength": "La contraseña debe tener al menos 6 caracteres",
    "admin.artists.passwordResetSuccess": "Contraseña restablecida con éxito",
    "admin.artists.passwordResetFailed": "Error al restablecer contraseña",
    "admin.artists.passwordCopied": "Contraseña copiada al portapapeles",
    "admin.artists.title": "Gestión de Artistas",
    "admin.artists.subtitle": "Gestionar y aprobar usuarios",
    "admin.artists.userNotFound": "No se encontraron usuarios",
    "admin.artists.noUsersFound": "No se encontraron usuarios",
    "admin.artists.noUsersForFilter": "No se encontraron usuarios para el filtro seleccionado.",
    "admin.artists.user": "Usuario",
    "admin.artists.balanceHeader": "Saldo",
    "admin.artists.status": "Estado",
    "admin.artists.registrationDate": "Fecha de Registro",
    "admin.artists.actions": "Acciones",
    "admin.artists.detail": "Detalle",
    "admin.artists.approve": "Aprobar",
    "admin.artists.reject": "Rechazar",
    "admin.artists.balanceBtn": "Saldo",
    "admin.artists.balanceAction": "Saldo",
    "admin.artists.ban": "Banear",
    "admin.artists.unban": "Quitar Ban",
    "admin.artists.approveUser": "Aprobar Usuario",
    "admin.artists.approveUserDialog": "Aprobar Usuario",
    "admin.artists.rejectUser": "Rechazar Usuario",
    "admin.artists.rejectUserDialog": "Rechazar Usuario",
    "admin.artists.banUser": "Banear Usuario",
    "admin.artists.banUserDialog": "Banear Usuario",
    "admin.artists.unbanUserDialog": "Quitar Ban",
    "admin.artists.assignPlan": "Asignar Plan",
    "admin.artists.assignPlanDialog": "Asignar Plan",
    "admin.artists.addBalance": "Agregar Saldo",
    "admin.artists.addBalanceDialog": "Agregar Saldo",
    "admin.artists.currentBanReason": "Motivo de ban actual",
    "admin.artists.noteOptional": "Nota (Opcional)",
    "admin.artists.notePlaceholder": "Nota para enviar al usuario...",
    "admin.artists.rejectReasonLabel": "Motivo de Rechazo (Obligatorio)",
    "admin.artists.rejectReasonPlaceholder": "Especifique el motivo de rechazo...",
    "admin.artists.banReasonLabel": "Motivo de Ban (Obligatorio)",
    "admin.artists.banReasonPlaceholder": "Ej.: Violación de derechos de autor, verificación de licencia pendiente...",
    "admin.artists.bannedUserRestrictions": "Los usuarios baneados no pueden enviar nuevos lanzamientos ni solicitar pagos.",
    "admin.artists.banWarning": "Los usuarios baneados no pueden enviar nuevos lanzamientos ni solicitar pagos.",
    "admin.artists.unbanNotePlaceholder": "Nota de desbaneo...",
    "admin.artists.planType": "Tipo de Plan",
    "admin.artists.selectPlan": "Seleccionar plan",
    "admin.artists.amount": "Monto ($)",
    "admin.artists.amountLabel": "Monto ($)",
    "admin.artists.amountPlaceholder": "Ej.: 100.00",
    "admin.artists.description": "Descripción",
    "admin.artists.descriptionLabel": "Descripción",
    "admin.artists.descriptionPlaceholder": "Ej.: Ganancias de streaming",
    "admin.artists.banAction": "Banear",
    "admin.artists.unbanAction": "Quitar Ban",
    "admin.artists.add": "Agregar",
    "admin.artists.userDetails": "Detalles del Usuario",
    "admin.artists.basicInfo": "Información Básica",
    "admin.artists.fullName": "Nombre Completo",
    "admin.artists.email": "Correo Electrónico",
    "admin.artists.addressInfo": "Información de Dirección",
    "admin.artists.address": "Dirección",
    "admin.artists.city": "Ciudad",
    "admin.artists.country": "País",
    "admin.artists.postalCode": "Código Postal",
    "admin.artists.loginInfo": "Info de Inicio de Sesión y Direcciones IP",
    "admin.artists.loginAndIpInfo": "Info de Inicio de Sesión y Direcciones IP",
    "admin.artists.registrationDateLabel": "Fecha de Registro",
    "admin.artists.lastLogin": "Último Inicio de Sesión",
    "admin.artists.lastLoginIp": "Última IP de Inicio de Sesión",
    "admin.artists.loginHistory": "Historial de Inicio de Sesión (Últimos 10)",
    "admin.artists.billingProfile": "Perfil de Facturación y Pagos",
    "admin.artists.billingAndPayoutProfile": "Perfil de Facturación y Pagos",
    "admin.artists.payoutMethodFull": "Método de Pago (Detalles Completos)",
    "admin.artists.bankTransfer": "Transferencia Bancaria",
    "admin.artists.lastUpdate": "Última actualización",
    "admin.artists.lastUpdated": "Última actualización",
    "admin.artists.statistics": "Estadísticas",
    "admin.artists.stats": "Estadísticas",
    "admin.artists.totalReleases": "Total de Lanzamientos",
    "admin.artists.supportTickets": "Tickets de Soporte",
    "admin.artists.payoutRequests": "Solicitudes de Pago",
    "admin.artists.banInfo": "Información de Ban",
    "admin.artists.banReason": "Motivo de Ban",
    "admin.artists.banReasonDetail": "Motivo de Ban",
    "admin.artists.notSpecified": "No especificado",
    "admin.artists.banDate": "Fecha de Ban",
    "admin.artists.referralInfo": "Información de Referencia",
    "admin.artists.referralCode": "Código de Referencia",
    "admin.artists.featureControl": "Control de Funciones (Desactivar)",
    "admin.artists.off": "(Desactivado)",
    "admin.artists.on": "(Activado)",
    "admin.artists.adminFullAccess": "Como administrador, tiene acceso completo a toda la información de pago.",
    "admin.artists.adminPaymentAccess": "Como administrador, tiene acceso completo a toda la información de pago.",
    "admin.artists.noPayoutMethod": "No se ha definido un método de pago",
    "admin.artists.paymentMethodNotDefined": "No se ha definido un método de pago",
    "admin.artists.resetPassword": "Restablecer Contraseña",
    "admin.artists.resetPasswordBtn": "Restablecer Contraseña",
    "admin.artists.resetPasswordTitle": "Restablecer Contraseña",
    "admin.artists.setNewPassword": "establecer una nueva contraseña para",
    "admin.artists.setNewPasswordFor": "establecer una nueva contraseña para",
    "admin.artists.newPassword": "Nueva Contraseña",
    "admin.artists.enterNewPassword": "Ingrese nueva contraseña",
    "admin.artists.newPasswordPlaceholder": "Ingrese nueva contraseña",
    "admin.artists.minChars": "Debe tener al menos 6 caracteres",
    "admin.artists.min6Chars": "Debe tener al menos 6 caracteres",
    "admin.artists.forcePasswordChange": "Obligar al usuario a cambiar la contraseña en el primer inicio de sesión",
    "admin.artists.generatedPassword": "Contraseña generada",
    "admin.artists.resetPasswordAction": "Restablecer Contraseña",
    "admin.artists.resetPasswordConfirm": "Restablecer Contraseña",
    "admin.artists.auditLog": "Historial de Transacciones de Pago (Registro de Auditoría)",
    "admin.payoutMethods.loadFailed": "Error al cargar métodos de pago",
    "admin.payoutMethods.revealFailed": "Error al revelar detalles",
    "admin.payoutMethods.billingLoadFailed": "Error al cargar perfil de facturación",
    "admin.payoutMethods.noUserSelected": "Ningún usuario seleccionado",
    "admin.payoutMethods.methodAdded": "Método de pago agregado",
    "admin.payoutMethods.operationFailed": "Operación fallida",
    "admin.payoutMethods.methodUpdated": "Método de pago actualizado",
    "admin.payoutMethods.methodDeleted": "Método de pago eliminado",
    "admin.payoutMethods.title": "Gestión de Métodos de Pago",
    "admin.payoutMethods.subtitle": "Ver y gestionar los métodos de pago de todos los usuarios",
    "admin.payoutMethods.description": "Ver y gestionar los métodos de pago de todos los usuarios",
    "admin.payoutMethods.searchPlaceholder": "Buscar por nombre de usuario o correo...",
    "admin.payoutMethods.filterByUserId": "Filtrar por ID de Usuario",
    "admin.payoutMethods.filterUserId": "Filtrar por ID de Usuario",
    "admin.payoutMethods.clear": "Limpiar",
    "admin.payoutMethods.notFound": "Método de Pago No Encontrado",
    "admin.payoutMethods.notFoundTitle": "Método de Pago No Encontrado",
    "admin.payoutMethods.noMethodForUser": "No hay método de pago para este usuario",
    "admin.payoutMethods.noMethodsYet": "Aún no se han agregado métodos de pago",
    "admin.payoutMethods.noMethodAddedYet": "Aún no se han agregado métodos de pago",
    "admin.payoutMethods.addMethod": "Agregar Método de Pago",
    "admin.payoutMethods.bankTransfer": "Transferencia Bancaria",
    "admin.payoutMethods.default": "Predeterminado",
    "admin.payoutMethods.verified": "Verificado",
    "admin.payoutMethods.pendingVerification": "Verificación Pendiente",
    "admin.payoutMethods.pending": "Verificación Pendiente",
    "admin.payoutMethods.notVerified": "No Verificado",
    "admin.payoutMethods.unverified": "No Verificado",
    "admin.payoutMethods.accountHolder": "Titular de la Cuenta",
    "admin.payoutMethods.bank": "Banco",
    "admin.payoutMethods.bankLabel": "Banco",
    "admin.payoutMethods.country": "País",
    "admin.payoutMethods.countryLabel": "País",
    "admin.payoutMethods.currency": "Moneda",
    "admin.payoutMethods.currencyLabel": "Moneda",
    "admin.payoutMethods.paypalEmail": "Correo PayPal",
    "admin.payoutMethods.lastUpdate": "Última actualización",
    "admin.payoutMethods.lastUpdated": "Última actualización",
    "admin.payoutMethods.profile": "Perfil",
    "admin.payoutMethods.revealFull": "Mostrar Completo",
    "admin.payoutMethods.editMethod": "Editar Método de Pago",
    "admin.payoutMethods.addNewMethod": "Agregar Nuevo Método de Pago",
    "admin.payoutMethods.addMethodTitle": "Agregar Nuevo Método de Pago",
    "admin.payoutMethods.adminOtpNotice": "No se requiere verificación OTP para cambios de administrador. Se enviará una notificación por correo al usuario.",
    "admin.payoutMethods.addEditDescription": "No se requiere verificación OTP para cambios de administrador. Se enviará una notificación por correo al usuario.",
    "admin.payoutMethods.userId": "ID de Usuario *",
    "admin.payoutMethods.userIdLabel": "ID de Usuario *",
    "admin.payoutMethods.enterUserId": "Ingrese ID de Usuario",
    "admin.payoutMethods.userIdPlaceholder": "Ingrese ID de Usuario",
    "admin.payoutMethods.ibanLabel": "IBAN *",
    "admin.payoutMethods.accountHolderName": "Nombre del Titular *",
    "admin.payoutMethods.accountHolderNameLabel": "Nombre del Titular *",
    "admin.payoutMethods.fullName": "Nombre Completo",
    "admin.payoutMethods.fullNamePlaceholder": "Nombre Completo",
    "admin.payoutMethods.bankName": "Nombre del Banco",
    "admin.payoutMethods.bankNameLabel": "Nombre del Banco",
    "admin.payoutMethods.optional": "Opcional",
    "admin.payoutMethods.optionalPlaceholder": "Opcional",
    "admin.payoutMethods.paypalEmailLabel": "Dirección de Correo PayPal *",
    "admin.payoutMethods.update": "Actualizar",
    "admin.payoutMethods.add": "Agregar",
    "admin.payoutMethods.fullPaymentInfo": "Información Completa de Pago",
    "admin.payoutMethods.fullPaymentDetails": "Detalles completos de pago",
    "admin.payoutMethods.auditLogNotice": "Esta información se registra en el registro de auditoría.",
    "admin.payoutMethods.auditLogWarning": "Esta información se registra en el registro de auditoría.",
    "admin.payoutMethods.sensitiveDataWarning": "Esta información es sensible y su visualización ha sido registrada.",
    "admin.payoutMethods.userLabel": "Usuario",
    "admin.payoutMethods.user": "Usuario",
    "admin.payoutMethods.bankInfo": "Información Bancaria",
    "admin.payoutMethods.bankDetails": "Detalles bancarios",
    "admin.payoutMethods.ibanFull": "IBAN (COMPLETO)",
    "admin.payoutMethods.accountHolderLabel": "Titular de la cuenta",
    "admin.payoutMethods.paypalInfo": "Información de PayPal",
    "admin.payoutMethods.paypalDetails": "Detalles de PayPal",
    "admin.payoutMethods.paypalEmailFull": "Correo PayPal (COMPLETO)",
    "admin.payoutMethods.statusVerified": "Verificado",
    "admin.payoutMethods.statusPending": "Pendiente",
    "admin.payoutMethods.statusNotVerified": "No Verificado",
    "admin.payoutMethods.statusUnverified": "No Verificado",
    "admin.payoutMethods.statusUnverifiedText": "No verificado",
    "admin.payoutMethods.statusLabel": "Estado",
    "admin.payoutMethods.close": "Cerrar",
    "admin.payoutMethods.deleteMethod": "Eliminar Método de Pago",
    "admin.payoutMethods.deleteWarning": "Esta acción no se puede deshacer y se enviará una notificación por correo al usuario.",
    "admin.payoutMethods.userColon": "Usuario",
    "admin.payoutMethods.delete": "Eliminar",
    "admin.payoutMethods.billingPayoutProfile": "Perfil de Facturación y Pagos",
    "admin.payoutMethods.billingProfileTitle": "Perfil de Facturación y Pagos",
    "admin.payoutMethods.maskedDataNotice": "Los datos sensibles están enmascarados por seguridad.",
    "admin.payoutMethods.maskedDataWarning": "Los datos sensibles están enmascarados por seguridad.",
    "admin.payoutMethods.identityInfo": "A) Información de Identidad",
    "admin.payoutMethods.profileType": "Tipo de Perfil",
    "admin.payoutMethods.business": "Empresa / Compañía",
    "admin.payoutMethods.individual": "Individual",
    "admin.payoutMethods.legalName": "Nombre Legal Completo",
    "admin.payoutMethods.displayName": "Nombre Visible",
    "admin.payoutMethods.email": "Correo Electrónico",
    "admin.payoutMethods.phone": "Teléfono",
    "admin.payoutMethods.businessInfo": "Información de la Empresa",
    "admin.payoutMethods.companyName": "Nombre de la Empresa",
    "admin.payoutMethods.registrationNumber": "No. de Registro de la Empresa",
    "admin.payoutMethods.companyRegNo": "No. de Registro de la Empresa",
    "admin.payoutMethods.vatNumber": "Número de IVA",
    "admin.payoutMethods.addressInfo": "B) Información de Dirección",
    "admin.payoutMethods.city": "Ciudad",
    "admin.payoutMethods.stateRegion": "Estado/Región",
    "admin.payoutMethods.state": "Estado/Región",
    "admin.payoutMethods.postalCode": "Código Postal",
    "admin.payoutMethods.addressLine1": "Dirección Línea 1",
    "admin.payoutMethods.addressLine2": "Dirección Línea 2",
    "admin.payoutMethods.taxInfo": "C) Información Fiscal (Obligatorio para Pagos)",
    "admin.payoutMethods.taxStatus": "Estado Fiscal",
    "admin.payoutMethods.taxMissing": "Faltante (No Puede Retirar)",
    "admin.payoutMethods.taxPersonal": "Individual",
    "admin.payoutMethods.personal": "Individual",
    "admin.payoutMethods.taxCorporate": "Corporativo",
    "admin.payoutMethods.corporate": "Corporativo",
    "admin.payoutMethods.taxCountry": "País Fiscal",
    "admin.payoutMethods.taxIdMasked": "No. Fiscal / ID (Enmascarado)",
    "admin.payoutMethods.taxWarning": "Este usuario no puede crear una solicitud de retiro sin completar la información fiscal",
    "admin.payoutMethods.activeMethod": "D) Método de Pago Activo",
    "admin.payoutMethods.method": "Método",
    "admin.payoutMethods.verificationStatus": "Estado de Verificación",
    "admin.payoutMethods.ibanMasked": "IBAN (Enmascarado)",
    "admin.payoutMethods.paypalMasked": "Correo PayPal (Enmascarado)",
    "admin.payoutMethods.updatedBy": "Actualizado por",
    "admin.payoutMethods.securityNotice": "Los datos sensibles (IBAN, ID Fiscal) están enmascarados por seguridad. Use el botón 'Mostrar Completo' para ver los detalles.",
    "admin.payoutMethods.revealIban": "Mostrar Completo (IBAN)",

    // changePassword
    "changePassword.title": "Cambiar Contraseña",
    "changePassword.description": "Por favor, cambie su contraseña por seguridad.",
    "changePassword.currentPassword": "Contraseña Actual",
    "changePassword.newPassword": "Nueva Contraseña",
    "changePassword.confirmPassword": "Nueva Contraseña (Confirmar)",
    "changePassword.showPasswords": "Mostrar contraseñas",
    "changePassword.submitBtn": "Cambiar Contraseña",
    "changePassword.passwordsNotMatch": "Las nuevas contraseñas no coinciden",
    "changePassword.passwordLength": "La contraseña debe tener al menos 6 caracteres",
    "changePassword.passwordChanged": "Contraseña cambiada con éxito",
    "changePassword.passwordChangeFailed": "Error al cambiar la contraseña",

    // suspended
    "suspended.title": "Cuenta Suspendida",
    "suspended.greeting": "Hola ",
    "suspended.reason": ", su cuenta ha sido suspendida por violación de licencia.",
    "suspended.restrictions": "Restricciones",
    "suspended.noUpload": "No puede subir nuevos lanzamientos",
    "suspended.noPayout": "No puede solicitar pagos",
    "suspended.noIban": "No puede actualizar la información IBAN",
    "suspended.accessible": "Características Accesibles",
    "suspended.viewReleases": "Puede ver sus lanzamientos existentes",
    "suspended.reviewHistory": "Puede revisar su historial de eliminaciones y reclamaciones",
    "suspended.createSupport": "Puede crear un ticket de soporte",
    "suspended.contactSupport": "Por favor, contacte a nuestro equipo de soporte para levantar la suspensión.",
    "suspended.contactBtn": "Ticket de Soporte",
    "suspended.createTicketTitle": "Crear Ticket de Soporte",
    "suspended.ticketSubmitted": "¡Su solicitud ha sido recibida!",
    "suspended.ticketTeamReply": "Nuestro equipo de soporte le responderá lo antes posible.",
    "suspended.fillFields": "Por favor, complete todos los campos",
    "suspended.ticketCreated": "Ticket de soporte creado",
    "suspended.ticketFailed": "Error al crear el ticket",
    "suspended.subjectPlaceholder": "Ej: Sobre el estado de suspensión de la cuenta",
    "suspended.messagePlaceholder": "¿Por qué cree que su cuenta fue suspendida? Explique su apelación en detalle...",
    "suspended.catAccount": "Cuenta / Apelación",
    "suspended.catTechnical": "Problema Técnico",
    "suspended.catRelease": "Problema de Lanzamiento",
};

export default es;
